// AUTO-GENERATED (gen_forum_i18n.py). Forum UI + labels, 21 languages (fr/en curated in forum.js).
export const FORUM_GEN = {
 "en": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Back to site",
   "login": "Log in",
   "logout": "Log out",
   "heroTitle": "Livestock Farmers Forum",
   "heroSubtitle": "Questions, advice and mutual support among passionate livestock farmers. Find an answer or start the conversation.",
   "newThread": "New topic",
   "searchPlaceholder": "Search for a topic…",
   "resultsFor": "result(s) for",
   "noResults": "No topics found. Try different keywords.",
   "recentDiscussions": "Recent discussions",
   "topMembers": "Most active members",
   "allCategories": "All categories",
   "subAll": "All",
   "sortRecent": "Recent",
   "sortUnanswered": "Unanswered",
   "sortResolved": "Resolved",
   "emptyCategory": "No topics yet. Start the conversation!",
   "threadOne": "topic",
   "threadMany": "topics",
   "replyOne": "reply",
   "replyMany": "replies",
   "by": "by",
   "resolved": "Resolved",
   "markResolved": "Mark as resolved",
   "unmarkResolved": "Remove resolved",
   "pendingModeration": "This topic is awaiting approval by the moderation team.",
   "yourReply": "Your reply",
   "replyPlaceholder": "Share your experience…",
   "replyPlaceholderGuest": "Log in to reply.",
   "publish": "Publish",
   "loginToReply": "Log in to reply",
   "relatedTopics": "Similar topics",
   "threadNotFound": "Topic not found.",
   "backToForum": "Back to forum",
   "loading": "Loading…",
   "memberNotFound": "Member not found.",
   "memberSince": "Member since",
   "contributionOne": "contribution",
   "contributionMany": "contributions",
   "memberThreads": "{name}'s topics",
   "memberNoThreads": "No topics posted yet.",
   "joinForum": "Join the forum",
   "forumLogin": "Forum login",
   "registerDesc": "Create a forum account (email, username, password) to join the community.",
   "loginDesc": "Log in with your email and password.",
   "email": "Email",
   "pseudo": "Username (publicly visible)",
   "password": "Password (min. 6 characters)",
   "elevageOptional": "Type of farming (optional)",
   "createAccount": "Create my account",
   "alreadyAccount": "Already have an account?",
   "newHere": "New here?",
   "switchToLogin": "Log in",
   "switchToRegister": "Create an account",
   "newThreadDesc": "Choose a category and describe your question to start the discussion.",
   "categoryPh": "Category…",
   "subcategoryPh": "Subcategory…",
   "threadTitlePh": "Title of your question (min. 8 characters)",
   "threadBodyPh": "Describe your situation or question…",
   "cancel": "Cancel",
   "toastPending": "Topic created! It will be visible after approval (first post from a new member).",
   "toastPublished": "Topic published!",
   "toastReplyPending": "Your reply will be visible after approval (first post).",
   "toastReplyPublished": "Reply published!",
   "toastResolvedOn": "Marked as resolved.",
   "toastResolvedOff": "Resolved status removed.",
   "toastWelcome": "Welcome to the forum!",
   "toastConnected": "Logged in!",
   "toastLoggedOut": "Logged out of the forum.",
   "error": "Error",
   "metaIndexTitle": "My Little Farm Forum — Farmers Helping Farmers",
   "metaIndexDesc": "Ask your questions about livestock farming, farm direct sales, cheesemaking, meat and eggs. My Little Farm farming community.",
   "badgeEquipe": "Team",
   "badgeExpert": "Expert",
   "badgeContrib": "Contributor",
   "badgeNew": "New"
  },
  "elevage": {
   "volailles": "Poultry & eggs",
   "fromage-lait": "Cheese & milk",
   "viande": "Meat",
   "maraichage": "Market gardening",
   "autre": "Other"
  },
  "cats": {
   "volailles-oeufs": "Poultry & Eggs",
   "fromage-lait": "Cheese & Milk",
   "viande": "Meat",
   "vente-business": "Sales & Business",
   "general-elevage": "General Farming"
  },
  "subs": {
   "alimentation-sante": "Feed & health",
   "production-ponte": "Production & laying",
   "materiel-poulailler": "Equipment & coop",
   "traite-sante": "Milking & animal health",
   "transformation-affinage": "Processing & aging",
   "reglementation-hygiene": "Regulations & hygiene",
   "elevage-croissance": "Raising & growth",
   "abattage-decoupe": "Slaughter & butchering",
   "reglementation": "Regulations",
   "fixer-prix": "Setting your prices",
   "vente-directe": "Farm direct sales / short supply chains",
   "communication": "Communication & social media",
   "reglementation-declarations": "Regulations & declarations",
   "presentation-membres": "Member introductions",
   "suggestions": "Suggestions for My Little Farm"
  }
 },
 "es": {
  "ui": {
   "navForum": "Foro",
   "backToSite": "Volver al sitio",
   "login": "Iniciar sesión",
   "logout": "Cerrar sesión",
   "heroTitle": "Foro de ganaderos",
   "heroSubtitle": "Preguntas, consejos y ayuda mutua entre apasionados de la ganadería. Encuentra una respuesta o inicia el debate.",
   "newThread": "Nuevo tema",
   "searchPlaceholder": "Buscar un tema…",
   "resultsFor": "resultado(s) para",
   "noResults": "No se encontró ningún tema. Prueba con otras palabras clave.",
   "recentDiscussions": "Debates recientes",
   "topMembers": "Miembros más activos",
   "allCategories": "Todas las categorías",
   "subAll": "Todo",
   "sortRecent": "Recientes",
   "sortUnanswered": "Sin respuesta",
   "sortResolved": "Resueltos",
   "emptyCategory": "Ningún tema por el momento. ¡Lanza el debate!",
   "threadOne": "tema",
   "threadMany": "temas",
   "replyOne": "respuesta",
   "replyMany": "respuestas",
   "by": "por",
   "resolved": "Resuelto",
   "markResolved": "Marcar como resuelto",
   "unmarkResolved": "Quitar resuelto",
   "pendingModeration": "Este tema está pendiente de validación por la moderación.",
   "yourReply": "Tu respuesta",
   "replyPlaceholder": "Comparte tu experiencia…",
   "replyPlaceholderGuest": "Inicia sesión para responder.",
   "publish": "Publicar",
   "loginToReply": "Iniciar sesión para responder",
   "relatedTopics": "Temas similares",
   "threadNotFound": "Tema no encontrado.",
   "backToForum": "Volver al foro",
   "loading": "Cargando…",
   "memberNotFound": "Miembro no encontrado.",
   "memberSince": "Miembro desde",
   "contributionOne": "contribución",
   "contributionMany": "contribuciones",
   "memberThreads": "Temas de {name}",
   "memberNoThreads": "Ningún tema publicado por el momento.",
   "joinForum": "Unirse al foro",
   "forumLogin": "Acceso al foro",
   "registerDesc": "Crea una cuenta en el foro (email, nombre de usuario, contraseña) para participar.",
   "loginDesc": "Inicia sesión con tu email y tu contraseña.",
   "email": "E-mail",
   "pseudo": "Nombre de usuario (visible públicamente)",
   "password": "Contraseña (mínimo 6 caracteres)",
   "elevageOptional": "Tipo de ganadería (opcional)",
   "createAccount": "Crear mi cuenta",
   "alreadyAccount": "¿Ya tienes cuenta?",
   "newHere": "¿Eres nuevo?",
   "switchToLogin": "Iniciar sesión",
   "switchToRegister": "Crear una cuenta",
   "newThreadDesc": "Elige una categoría y describe tu pregunta para iniciar el debate.",
   "categoryPh": "Categoría…",
   "subcategoryPh": "Subcategoría…",
   "threadTitlePh": "Título de tu pregunta (mínimo 8 caracteres)",
   "threadBodyPh": "Describe tu situación o tu pregunta…",
   "cancel": "Cancelar",
   "toastPending": "¡Tema creado! Será visible tras la validación (1er mensaje de un nuevo miembro).",
   "toastPublished": "¡Tema publicado!",
   "toastReplyPending": "Tu respuesta será visible tras la validación (1er mensaje).",
   "toastReplyPublished": "¡Respuesta publicada!",
   "toastResolvedOn": "Marcado como resuelto.",
   "toastResolvedOff": "Resuelto eliminado.",
   "toastWelcome": "¡Bienvenido al foro!",
   "toastConnected": "¡Sesión iniciada!",
   "toastLoggedOut": "Sesión cerrada en el foro.",
   "error": "Error",
   "metaIndexTitle": "Foro Mi Pequeña Granja — Ayuda mutua entre ganaderos",
   "metaIndexDesc": "Haz tus preguntas sobre ganadería, venta directa, elaboración de quesos, carne y huevos. Comunidad de ganaderos de Mi Pequeña Granja.",
   "badgeEquipe": "Equipo",
   "badgeExpert": "Experto",
   "badgeContrib": "Colaborador",
   "badgeNew": "Nuevo"
  },
  "elevage": {
   "volailles": "Aves de corral & huevos",
   "fromage-lait": "Queso & leche",
   "viande": "Carne",
   "maraichage": "Huerta",
   "autre": "Otro"
  },
  "cats": {
   "volailles-oeufs": "Aves de corral & Huevos",
   "fromage-lait": "Queso & Leche",
   "viande": "Carne",
   "vente-business": "Venta & Negocio",
   "general-elevage": "Ganadería general"
  },
  "subs": {
   "alimentation-sante": "Alimentación & salud",
   "production-ponte": "Producción & puesta",
   "materiel-poulailler": "Material & gallinero",
   "traite-sante": "Ordeño & salud animal",
   "transformation-affinage": "Elaboración & maduración",
   "reglementation-hygiene": "Normativa & higiene",
   "elevage-croissance": "Cría & crecimiento",
   "abattage-decoupe": "Sacrificio & despiece",
   "reglementation": "Normativa",
   "fixer-prix": "Fijar los precios",
   "vente-directe": "Vender en directo / circuitos cortos",
   "communication": "Comunicación & redes sociales",
   "reglementation-declarations": "Normativa & declaraciones",
   "presentation-membres": "Presentación de los miembros",
   "suggestions": "Sugerencias para Mi Pequeña Granja"
  }
 },
 "it": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Torna al sito",
   "login": "Accedi",
   "logout": "Esci",
   "heroTitle": "Forum degli allevatori",
   "heroSubtitle": "Domande, consigli e aiuto reciproco tra appassionati di allevamento. Trova una risposta o avvia la discussione.",
   "newThread": "Nuovo argomento",
   "searchPlaceholder": "Cerca un argomento…",
   "resultsFor": "risultato/i per",
   "noResults": "Nessun argomento trovato. Prova con altre parole chiave.",
   "recentDiscussions": "Discussioni recenti",
   "topMembers": "Membri più attivi",
   "allCategories": "Tutte le categorie",
   "subAll": "Tutti",
   "sortRecent": "Recenti",
   "sortUnanswered": "Senza risposta",
   "sortResolved": "Risolti",
   "emptyCategory": "Nessun argomento per ora. Avvia la discussione!",
   "threadOne": "argomento",
   "threadMany": "argomenti",
   "replyOne": "risposta",
   "replyMany": "risposte",
   "by": "di",
   "resolved": "Risolto",
   "markResolved": "Segna come risolto",
   "unmarkResolved": "Rimuovi risolto",
   "pendingModeration": "Questo argomento è in attesa di approvazione da parte della moderazione.",
   "yourReply": "La tua risposta",
   "replyPlaceholder": "Condividi la tua esperienza…",
   "replyPlaceholderGuest": "Accedi per rispondere.",
   "publish": "Pubblica",
   "loginToReply": "Accedi per rispondere",
   "relatedTopics": "Argomenti simili",
   "threadNotFound": "Argomento non trovato.",
   "backToForum": "Torna al forum",
   "loading": "Caricamento…",
   "memberNotFound": "Membro non trovato.",
   "memberSince": "Membro da",
   "contributionOne": "contributo",
   "contributionMany": "contributi",
   "memberThreads": "Argomenti di {name}",
   "memberNoThreads": "Nessun argomento pubblicato per ora.",
   "joinForum": "Unisciti al forum",
   "forumLogin": "Accesso al forum",
   "registerDesc": "Crea un account forum (email, nome utente, password) per partecipare.",
   "loginDesc": "Accedi con la tua email e la tua password.",
   "email": "E-mail",
   "pseudo": "Nome utente (visibile pubblicamente)",
   "password": "Password (min. 6 caratteri)",
   "elevageOptional": "Tipo di allevamento (opzionale)",
   "createAccount": "Crea il mio account",
   "alreadyAccount": "Hai già un account?",
   "newHere": "Nuovo qui?",
   "switchToLogin": "Accedi",
   "switchToRegister": "Crea un account",
   "newThreadDesc": "Scegli una categoria e descrivi la tua domanda per avviare la discussione.",
   "categoryPh": "Categoria…",
   "subcategoryPh": "Sottocategoria…",
   "threadTitlePh": "Titolo della tua domanda (min. 8 caratteri)",
   "threadBodyPh": "Descrivi la tua situazione o la tua domanda…",
   "cancel": "Annulla",
   "toastPending": "Argomento creato! Sarà visibile dopo la validazione (1° messaggio di un nuovo membro).",
   "toastPublished": "Argomento pubblicato!",
   "toastReplyPending": "La tua risposta sarà visibile dopo la validazione (1° messaggio).",
   "toastReplyPublished": "Risposta pubblicata!",
   "toastResolvedOn": "Segnato come risolto.",
   "toastResolvedOff": "Risolto rimosso.",
   "toastWelcome": "Benvenuto/a nel forum!",
   "toastConnected": "Connesso!",
   "toastLoggedOut": "Disconnesso dal forum.",
   "error": "Errore",
   "metaIndexTitle": "Forum La Mia Piccola Fattoria — Aiuto tra allevatori",
   "metaIndexDesc": "Fai le tue domande sull'allevamento, la vendita diretta, la trasformazione casearia, la carne e le uova. Comunità di allevatori La Mia Piccola Fattoria.",
   "badgeEquipe": "Staff",
   "badgeExpert": "Esperto",
   "badgeContrib": "Contributore",
   "badgeNew": "Nuovo"
  },
  "elevage": {
   "volailles": "Pollame & uova",
   "fromage-lait": "Formaggio & latte",
   "viande": "Carne",
   "maraichage": "Orticoltura",
   "autre": "Altro"
  },
  "cats": {
   "volailles-oeufs": "Pollame & Uova",
   "fromage-lait": "Formaggio & Latte",
   "viande": "Carne",
   "vente-business": "Vendita & Business",
   "general-elevage": "Allevamento generale"
  },
  "subs": {
   "alimentation-sante": "Alimentazione & salute",
   "production-ponte": "Produzione & deposizione",
   "materiel-poulailler": "Attrezzatura & pollaio",
   "traite-sante": "Mungitura & salute animale",
   "transformation-affinage": "Trasformazione & stagionatura",
   "reglementation-hygiene": "Normativa & igiene",
   "elevage-croissance": "Allevamento & crescita",
   "abattage-decoupe": "Macellazione & taglio",
   "reglementation": "Normativa",
   "fixer-prix": "Fissare i prezzi",
   "vente-directe": "Vendita diretta / filiera corta",
   "communication": "Comunicazione & social media",
   "reglementation-declarations": "Normativa & dichiarazioni",
   "presentation-membres": "Presentazione dei membri",
   "suggestions": "Suggerimenti per La Mia Piccola Fattoria"
  }
 },
 "de": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Zurück zur Website",
   "login": "Anmelden",
   "logout": "Abmelden",
   "heroTitle": "Forum für Tierhalter",
   "heroSubtitle": "Fragen, Tipps und gegenseitige Unterstützung unter Landwirtschaftsbegeisterten. Finden Sie eine Antwort oder starten Sie eine Diskussion.",
   "newThread": "Neues Thema",
   "searchPlaceholder": "Thema suchen…",
   "resultsFor": "Ergebnis(se) für",
   "noResults": "Kein Thema gefunden. Versuchen Sie andere Suchbegriffe.",
   "recentDiscussions": "Aktuelle Diskussionen",
   "topMembers": "Aktivste Mitglieder",
   "allCategories": "Alle Kategorien",
   "subAll": "Alle",
   "sortRecent": "Neueste",
   "sortUnanswered": "Unbeantwortet",
   "sortResolved": "Gelöst",
   "emptyCategory": "Noch kein Thema vorhanden. Starten Sie die Diskussion!",
   "threadOne": "Thema",
   "threadMany": "Themen",
   "replyOne": "Antwort",
   "replyMany": "Antworten",
   "by": "von",
   "resolved": "Gelöst",
   "markResolved": "Als gelöst markieren",
   "unmarkResolved": "Gelöst entfernen",
   "pendingModeration": "Dieses Thema wartet auf die Freigabe durch die Moderation.",
   "yourReply": "Ihre Antwort",
   "replyPlaceholder": "Teilen Sie Ihre Erfahrung…",
   "replyPlaceholderGuest": "Melden Sie sich an, um zu antworten.",
   "publish": "Veröffentlichen",
   "loginToReply": "Anmelden um zu antworten",
   "relatedTopics": "Ähnliche Themen",
   "threadNotFound": "Thema nicht gefunden.",
   "backToForum": "Zurück zum Forum",
   "loading": "Wird geladen…",
   "memberNotFound": "Mitglied nicht gefunden.",
   "memberSince": "Mitglied seit",
   "contributionOne": "Beitrag",
   "contributionMany": "Beiträge",
   "memberThreads": "Themen von {name}",
   "memberNoThreads": "Noch keine Themen veröffentlicht.",
   "joinForum": "Forum beitreten",
   "forumLogin": "Forum-Anmeldung",
   "registerDesc": "Erstellen Sie ein Forum-Konto (E-Mail, Benutzername, Passwort), um mitzumachen.",
   "loginDesc": "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.",
   "email": "E-Mail",
   "pseudo": "Benutzername (öffentlich sichtbar)",
   "password": "Passwort (mind. 6 Zeichen)",
   "elevageOptional": "Art der Tierhaltung (optional)",
   "createAccount": "Konto erstellen",
   "alreadyAccount": "Bereits ein Konto?",
   "newHere": "Neu hier?",
   "switchToLogin": "Anmelden",
   "switchToRegister": "Konto erstellen",
   "newThreadDesc": "Wählen Sie eine Kategorie und beschreiben Sie Ihre Frage, um die Diskussion zu starten.",
   "categoryPh": "Kategorie…",
   "subcategoryPh": "Unterkategorie…",
   "threadTitlePh": "Titel Ihrer Frage (mind. 8 Zeichen)",
   "threadBodyPh": "Beschreiben Sie Ihre Situation oder Ihre Frage…",
   "cancel": "Abbrechen",
   "toastPending": "Thema erstellt! Es wird nach der Freigabe sichtbar sein (erste Nachricht eines neuen Mitglieds).",
   "toastPublished": "Thema veröffentlicht!",
   "toastReplyPending": "Ihre Antwort wird nach der Freigabe sichtbar sein (erste Nachricht).",
   "toastReplyPublished": "Antwort veröffentlicht!",
   "toastResolvedOn": "Als gelöst markiert.",
   "toastResolvedOff": "Gelöst-Markierung entfernt.",
   "toastWelcome": "Willkommen im Forum!",
   "toastConnected": "Angemeldet!",
   "toastLoggedOut": "Vom Forum abgemeldet.",
   "error": "Fehler",
   "metaIndexTitle": "Forum Mein kleiner Bauernhof — Gegenseitige Hilfe unter Tierhaltern",
   "metaIndexDesc": "Stellen Sie Ihre Fragen zur Tierhaltung, zum Direktverkauf, zur Käseherstellung, zu Fleisch und Eiern. Gemeinschaft der Tierhalter von Mein kleiner Bauernhof.",
   "badgeEquipe": "Team",
   "badgeExpert": "Experte",
   "badgeContrib": "Mitwirkender",
   "badgeNew": "Neu"
  },
  "elevage": {
   "volailles": "Geflügel & Eier",
   "fromage-lait": "Käse & Milch",
   "viande": "Fleisch",
   "maraichage": "Gemüseanbau",
   "autre": "Sonstiges"
  },
  "cats": {
   "volailles-oeufs": "Geflügel & Eier",
   "fromage-lait": "Käse & Milch",
   "viande": "Fleisch",
   "vente-business": "Verkauf & Business",
   "general-elevage": "Allgemeine Tierhaltung"
  },
  "subs": {
   "alimentation-sante": "Fütterung & Gesundheit",
   "production-ponte": "Produktion & Eierlage",
   "materiel-poulailler": "Ausstattung & Hühnerstall",
   "traite-sante": "Melken & Tiergesundheit",
   "transformation-affinage": "Verarbeitung & Reifung",
   "reglementation-hygiene": "Vorschriften & Hygiene",
   "elevage-croissance": "Aufzucht & Wachstum",
   "abattage-decoupe": "Schlachtung & Zerlegung",
   "reglementation": "Vorschriften",
   "fixer-prix": "Preise festlegen",
   "vente-directe": "Direktverkauf / kurze Vertriebswege",
   "communication": "Kommunikation & soziale Medien",
   "reglementation-declarations": "Vorschriften & Meldepflichten",
   "presentation-membres": "Mitgliedervorstellung",
   "suggestions": "Vorschläge für Mein kleiner Bauernhof"
  }
 },
 "nl": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Terug naar de site",
   "login": "Inloggen",
   "logout": "Uitloggen",
   "heroTitle": "Forum voor veehouders",
   "heroSubtitle": "Vragen, tips en hulp tussen liefhebbers van veeteelt. Vind een antwoord of start een discussie.",
   "newThread": "Nieuw onderwerp",
   "searchPlaceholder": "Zoek een onderwerp…",
   "resultsFor": "resultaat/resultaten voor",
   "noResults": "Geen onderwerpen gevonden. Probeer andere zoekwoorden.",
   "recentDiscussions": "Recente discussies",
   "topMembers": "Meest actieve leden",
   "allCategories": "Alle categorieën",
   "subAll": "Alles",
   "sortRecent": "Recent",
   "sortUnanswered": "Onbeantwoord",
   "sortResolved": "Opgelost",
   "emptyCategory": "Nog geen onderwerpen. Start de discussie!",
   "threadOne": "onderwerp",
   "threadMany": "onderwerpen",
   "replyOne": "reactie",
   "replyMany": "reacties",
   "by": "door",
   "resolved": "Opgelost",
   "markResolved": "Markeer als opgelost",
   "unmarkResolved": "Verwijder opgelost",
   "pendingModeration": "Dit onderwerp wacht op goedkeuring door de moderatie.",
   "yourReply": "Jouw reactie",
   "replyPlaceholder": "Deel jouw ervaring…",
   "replyPlaceholderGuest": "Log in om te reageren.",
   "publish": "Publiceren",
   "loginToReply": "Inloggen om te reageren",
   "relatedTopics": "Gerelateerde onderwerpen",
   "threadNotFound": "Onderwerp niet gevonden.",
   "backToForum": "Terug naar het forum",
   "loading": "Laden…",
   "memberNotFound": "Lid niet gevonden.",
   "memberSince": "Lid sinds",
   "contributionOne": "bijdrage",
   "contributionMany": "bijdragen",
   "memberThreads": "Onderwerpen van {name}",
   "memberNoThreads": "Nog geen onderwerpen geplaatst.",
   "joinForum": "Word lid van het forum",
   "forumLogin": "Inloggen op het forum",
   "registerDesc": "Maak een forumaccount aan (e-mail, gebruikersnaam, wachtwoord) om deel te nemen.",
   "loginDesc": "Log in met je e-mailadres en wachtwoord.",
   "email": "E-mail",
   "pseudo": "Gebruikersnaam (zichtbaar voor anderen)",
   "password": "Wachtwoord (min. 6 tekens)",
   "elevageOptional": "Type veeteelt (optioneel)",
   "createAccount": "Account aanmaken",
   "alreadyAccount": "Al een account?",
   "newHere": "Nieuw hier?",
   "switchToLogin": "Inloggen",
   "switchToRegister": "Account aanmaken",
   "newThreadDesc": "Kies een categorie en beschrijf je vraag om de discussie te starten.",
   "categoryPh": "Categorie…",
   "subcategoryPh": "Subcategorie…",
   "threadTitlePh": "Titel van je vraag (min. 8 tekens)",
   "threadBodyPh": "Beschrijf je situatie of je vraag…",
   "cancel": "Annuleren",
   "toastPending": "Onderwerp aangemaakt! Het wordt zichtbaar na goedkeuring (1e bericht van een nieuw lid).",
   "toastPublished": "Onderwerp gepubliceerd!",
   "toastReplyPending": "Je reactie wordt zichtbaar na goedkeuring (1e bericht).",
   "toastReplyPublished": "Reactie gepubliceerd!",
   "toastResolvedOn": "Gemarkeerd als opgelost.",
   "toastResolvedOff": "Opgelost verwijderd.",
   "toastWelcome": "Welkom op het forum!",
   "toastConnected": "Ingelogd!",
   "toastLoggedOut": "Uitgelogd van het forum.",
   "error": "Fout",
   "metaIndexTitle": "Forum Ma Petite Ferme — Hulp tussen veehouders",
   "metaIndexDesc": "Stel je vragen over veeteelt, rechtstreekse verkoop, kaasbereiding, vlees en eieren. Gemeenschap van veehouders Ma Petite Ferme.",
   "badgeEquipe": "Team",
   "badgeExpert": "Expert",
   "badgeContrib": "Bijdrager",
   "badgeNew": "Nieuw"
  },
  "elevage": {
   "volailles": "Pluimvee & eieren",
   "fromage-lait": "Kaas & melk",
   "viande": "Vlees",
   "maraichage": "Groenteteelt",
   "autre": "Overige"
  },
  "cats": {
   "volailles-oeufs": "Pluimvee & Eieren",
   "fromage-lait": "Kaas & Melk",
   "viande": "Vlees",
   "vente-business": "Verkoop & Bedrijf",
   "general-elevage": "Algemene veeteelt"
  },
  "subs": {
   "alimentation-sante": "Voeding & gezondheid",
   "production-ponte": "Productie & eileg",
   "materiel-poulailler": "Materiaal & kippenhok",
   "traite-sante": "Melken & diergezondheid",
   "transformation-affinage": "Verwerking & rijping",
   "reglementation-hygiene": "Regelgeving & hygiëne",
   "elevage-croissance": "Opfok & groei",
   "abattage-decoupe": "Slacht & uitsnijden",
   "reglementation": "Regelgeving",
   "fixer-prix": "Prijzen bepalen",
   "vente-directe": "Rechtstreekse verkoop / korte keten",
   "communication": "Communicatie & sociale media",
   "reglementation-declarations": "Regelgeving & aangiften",
   "presentation-membres": "Voorstelling van leden",
   "suggestions": "Suggesties voor Ma Petite Ferme"
  }
 },
 "sv": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Tillbaka till sidan",
   "login": "Logga in",
   "logout": "Logga ut",
   "heroTitle": "Forum för djuruppfödare",
   "heroSubtitle": "Frågor, råd och hjälp mellan passionerade uppfödare. Hitta ett svar eller starta en diskussion.",
   "newThread": "Nytt ämne",
   "searchPlaceholder": "Sök efter ett ämne…",
   "resultsFor": "resultat för",
   "noResults": "Inga ämnen hittades. Prova andra sökord.",
   "recentDiscussions": "Senaste diskussioner",
   "topMembers": "Mest aktiva medlemmar",
   "allCategories": "Alla kategorier",
   "subAll": "Alla",
   "sortRecent": "Senaste",
   "sortUnanswered": "Obesvarade",
   "sortResolved": "Lösta",
   "emptyCategory": "Inga ämnen ännu. Starta diskussionen!",
   "threadOne": "ämne",
   "threadMany": "ämnen",
   "replyOne": "svar",
   "replyMany": "svar",
   "by": "av",
   "resolved": "Löst",
   "markResolved": "Markera som löst",
   "unmarkResolved": "Ta bort löst",
   "pendingModeration": "Det här ämnet väntar på godkännande av moderatorn.",
   "yourReply": "Ditt svar",
   "replyPlaceholder": "Dela med dig av dina erfarenheter…",
   "replyPlaceholderGuest": "Logga in för att svara.",
   "publish": "Publicera",
   "loginToReply": "Logga in för att svara",
   "relatedTopics": "Liknande ämnen",
   "threadNotFound": "Ämnet hittades inte.",
   "backToForum": "Tillbaka till forumet",
   "loading": "Laddar…",
   "memberNotFound": "Medlemmen hittades inte.",
   "memberSince": "Medlem sedan",
   "contributionOne": "bidrag",
   "contributionMany": "bidrag",
   "memberThreads": "{name}s ämnen",
   "memberNoThreads": "Inga publicerade ämnen ännu.",
   "joinForum": "Gå med i forumet",
   "forumLogin": "Logga in på forumet",
   "registerDesc": "Skapa ett forumkonto (e-post, användarnamn, lösenord) för att delta.",
   "loginDesc": "Logga in med din e-post och ditt lösenord.",
   "email": "E-post",
   "pseudo": "Användarnamn (synligt offentligt)",
   "password": "Lösenord (minst 6 tecken)",
   "elevageOptional": "Typ av djurhållning (valfritt)",
   "createAccount": "Skapa mitt konto",
   "alreadyAccount": "Redan ett konto?",
   "newHere": "Ny här?",
   "switchToLogin": "Logga in",
   "switchToRegister": "Skapa ett konto",
   "newThreadDesc": "Välj en kategori och beskriv din fråga för att starta diskussionen.",
   "categoryPh": "Kategori…",
   "subcategoryPh": "Underkategori…",
   "threadTitlePh": "Titel på din fråga (minst 8 tecken)",
   "threadBodyPh": "Beskriv din situation eller din fråga…",
   "cancel": "Avbryt",
   "toastPending": "Ämne skapat! Det blir synligt efter godkännande (1:a inlägget från en ny medlem).",
   "toastPublished": "Ämne publicerat!",
   "toastReplyPending": "Ditt svar blir synligt efter godkännande (1:a inlägget).",
   "toastReplyPublished": "Svar publicerat!",
   "toastResolvedOn": "Markerat som löst.",
   "toastResolvedOff": "Löst borttaget.",
   "toastWelcome": "Välkommen till forumet!",
   "toastConnected": "Inloggad!",
   "toastLoggedOut": "Utloggad från forumet.",
   "error": "Fel",
   "metaIndexTitle": "Forum Ma Petite Ferme — Hjälp mellan uppfödare",
   "metaIndexDesc": "Ställ dina frågor om djurhållning, direktförsäljning, ostförädling, kött och ägg. Uppfödargemenskapen Ma Petite Ferme.",
   "badgeEquipe": "Team",
   "badgeExpert": "Expert",
   "badgeContrib": "Bidragsgivare",
   "badgeNew": "Ny"
  },
  "elevage": {
   "volailles": "Fjäderfä & ägg",
   "fromage-lait": "Ost & mjölk",
   "viande": "Kött",
   "maraichage": "Grönsaksodling",
   "autre": "Övrigt"
  },
  "cats": {
   "volailles-oeufs": "Fjäderfä & Ägg",
   "fromage-lait": "Ost & Mjölk",
   "viande": "Kött",
   "vente-business": "Försäljning & Affärer",
   "general-elevage": "Allmän djurhållning"
  },
  "subs": {
   "alimentation-sante": "Utfodring & hälsa",
   "production-ponte": "Produktion & äggläggning",
   "materiel-poulailler": "Utrustning & hönshus",
   "traite-sante": "Mjölkning & djurhälsa",
   "transformation-affinage": "Förädling & lagring",
   "reglementation-hygiene": "Regler & hygien",
   "elevage-croissance": "Uppfödning & tillväxt",
   "abattage-decoupe": "Slakt & styckning",
   "reglementation": "Regler & bestämmelser",
   "fixer-prix": "Sätta sina priser",
   "vente-directe": "Direktförsäljning / korta distributionskedjor",
   "communication": "Kommunikation & sociala medier",
   "reglementation-declarations": "Regler & anmälningar",
   "presentation-membres": "Presentation av medlemmar",
   "suggestions": "Förslag till Ma Petite Ferme"
  }
 },
 "da": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Tilbage til siden",
   "login": "Log ind",
   "logout": "Log ud",
   "heroTitle": "Landmændenes forum",
   "heroSubtitle": "Spørgsmål, råd og hjælp mellem passionerede dyreholdere. Find et svar eller start en diskussion.",
   "newThread": "Nyt emne",
   "searchPlaceholder": "Søg efter et emne…",
   "resultsFor": "resultat(er) for",
   "noResults": "Ingen emner fundet. Prøv andre søgeord.",
   "recentDiscussions": "Seneste diskussioner",
   "topMembers": "Mest aktive medlemmer",
   "allCategories": "Alle kategorier",
   "subAll": "Alle",
   "sortRecent": "Seneste",
   "sortUnanswered": "Ubesvarede",
   "sortResolved": "Løste",
   "emptyCategory": "Ingen emner endnu. Start diskussionen!",
   "threadOne": "emne",
   "threadMany": "emner",
   "replyOne": "svar",
   "replyMany": "svar",
   "by": "af",
   "resolved": "Løst",
   "markResolved": "Marker som løst",
   "unmarkResolved": "Fjern løst",
   "pendingModeration": "Dette emne afventer godkendelse fra moderationen.",
   "yourReply": "Dit svar",
   "replyPlaceholder": "Del din erfaring…",
   "replyPlaceholderGuest": "Log ind for at svare.",
   "publish": "Publicer",
   "loginToReply": "Log ind for at svare",
   "relatedTopics": "Lignende emner",
   "threadNotFound": "Emnet blev ikke fundet.",
   "backToForum": "Tilbage til forummet",
   "loading": "Indlæser…",
   "memberNotFound": "Medlem ikke fundet.",
   "memberSince": "Medlem siden",
   "contributionOne": "bidrag",
   "contributionMany": "bidrag",
   "memberThreads": "{name}s emner",
   "memberNoThreads": "Ingen emner publiceret endnu.",
   "joinForum": "Tilmeld dig forummet",
   "forumLogin": "Log ind på forummet",
   "registerDesc": "Opret en forumkonto (e-mail, brugernavn, adgangskode) for at deltage.",
   "loginDesc": "Log ind med din e-mail og adgangskode.",
   "email": "E-mail",
   "pseudo": "Brugernavn (synligt for alle)",
   "password": "Adgangskode (min. 6 tegn)",
   "elevageOptional": "Type af dyrehold (valgfrit)",
   "createAccount": "Opret min konto",
   "alreadyAccount": "Har du allerede en konto?",
   "newHere": "Ny her?",
   "switchToLogin": "Log ind",
   "switchToRegister": "Opret konto",
   "newThreadDesc": "Vælg en kategori og beskriv dit spørgsmål for at starte diskussionen.",
   "categoryPh": "Kategori…",
   "subcategoryPh": "Underkategori…",
   "threadTitlePh": "Titel på dit spørgsmål (min. 8 tegn)",
   "threadBodyPh": "Beskriv din situation eller dit spørgsmål…",
   "cancel": "Annuller",
   "toastPending": "Emne oprettet! Det bliver synligt efter godkendelse (1. besked fra et nyt medlem).",
   "toastPublished": "Emne publiceret!",
   "toastReplyPending": "Dit svar bliver synligt efter godkendelse (1. besked).",
   "toastReplyPublished": "Svar publiceret!",
   "toastResolvedOn": "Markeret som løst.",
   "toastResolvedOff": "Løst fjernet.",
   "toastWelcome": "Velkommen til forummet!",
   "toastConnected": "Logget ind!",
   "toastLoggedOut": "Logget ud af forummet.",
   "error": "Fejl",
   "metaIndexTitle": "Forum Min Lille Gård — Hjælp mellem dyreholdere",
   "metaIndexDesc": "Stil dine spørgsmål om dyrehold, direkte salg, ostefremstilling, kød og æg. Fællesskab for dyreholdere på Min Lille Gård.",
   "badgeEquipe": "Team",
   "badgeExpert": "Ekspert",
   "badgeContrib": "Bidragyder",
   "badgeNew": "Ny"
  },
  "elevage": {
   "volailles": "Fjerkræ & æg",
   "fromage-lait": "Ost & mælk",
   "viande": "Kød",
   "maraichage": "Grøntsagsdyrkning",
   "autre": "Andet"
  },
  "cats": {
   "volailles-oeufs": "Fjerkræ & æg",
   "fromage-lait": "Ost & mælk",
   "viande": "Kød",
   "vente-business": "Salg & forretning",
   "general-elevage": "Generelt dyrehold"
  },
  "subs": {
   "alimentation-sante": "Foder & sundhed",
   "production-ponte": "Produktion & æggelægning",
   "materiel-poulailler": "Udstyr & hønsehus",
   "traite-sante": "Malkning & dyresundhed",
   "transformation-affinage": "Forarbejdning & modning",
   "reglementation-hygiene": "Regler & hygiejne",
   "elevage-croissance": "Opdræt & vækst",
   "abattage-decoupe": "Slagtning & udskæring",
   "reglementation": "Regler & lovgivning",
   "fixer-prix": "Fastsættelse af priser",
   "vente-directe": "Direkte salg / korte forsyningskæder",
   "communication": "Kommunikation & sociale medier",
   "reglementation-declarations": "Regler & indberetninger",
   "presentation-membres": "Præsentation af medlemmer",
   "suggestions": "Forslag til Min Lille Gård"
  }
 },
 "el": {
  "ui": {
   "navForum": "Φόρουμ",
   "backToSite": "Επιστροφή στον ιστότοπο",
   "login": "Σύνδεση",
   "logout": "Αποσύνδεση",
   "heroTitle": "Φόρουμ Κτηνοτρόφων",
   "heroSubtitle": "Ερωτήσεις, συμβουλές και αλληλοβοήθεια μεταξύ λάτρεων της κτηνοτροφίας. Βρείτε μια απάντηση ή ξεκινήστε τη συζήτηση.",
   "newThread": "Νέο θέμα",
   "searchPlaceholder": "Αναζήτηση θέματος…",
   "resultsFor": "αποτέλεσμα(τα) για",
   "noResults": "Δεν βρέθηκε κανένα θέμα. Δοκιμάστε άλλες λέξεις-κλειδιά.",
   "recentDiscussions": "Πρόσφατες συζητήσεις",
   "topMembers": "Πιο ενεργά μέλη",
   "allCategories": "Όλες οι κατηγορίες",
   "subAll": "Όλα",
   "sortRecent": "Πρόσφατα",
   "sortUnanswered": "Αναπάντητα",
   "sortResolved": "Λυμένα",
   "emptyCategory": "Κανένα θέμα ακόμα. Ξεκινήστε τη συζήτηση!",
   "threadOne": "θέμα",
   "threadMany": "θέματα",
   "replyOne": "απάντηση",
   "replyMany": "απαντήσεις",
   "by": "από",
   "resolved": "Λυμένο",
   "markResolved": "Σήμανση ως λυμένο",
   "unmarkResolved": "Αφαίρεση σήμανσης",
   "pendingModeration": "Αυτό το θέμα αναμένει έγκριση από τη διαχείριση.",
   "yourReply": "Η απάντησή σας",
   "replyPlaceholder": "Μοιραστείτε την εμπειρία σας…",
   "replyPlaceholderGuest": "Συνδεθείτε για να απαντήσετε.",
   "publish": "Δημοσίευση",
   "loginToReply": "Σύνδεση για απάντηση",
   "relatedTopics": "Παρόμοια θέματα",
   "threadNotFound": "Το θέμα δεν βρέθηκε.",
   "backToForum": "Επιστροφή στο φόρουμ",
   "loading": "Φόρτωση…",
   "memberNotFound": "Το μέλος δεν βρέθηκε.",
   "memberSince": "Μέλος από",
   "contributionOne": "συνεισφορά",
   "contributionMany": "συνεισφορές",
   "memberThreads": "Θέματα του {name}",
   "memberNoThreads": "Δεν έχει δημοσιευτεί κανένα θέμα ακόμα.",
   "joinForum": "Εγγραφή στο φόρουμ",
   "forumLogin": "Σύνδεση στο φόρουμ",
   "registerDesc": "Δημιουργήστε έναν λογαριασμό φόρουμ (email, ψευδώνυμο, κωδικός) για να συμμετέχετε.",
   "loginDesc": "Συνδεθείτε με το email και τον κωδικό σας.",
   "email": "E-mail",
   "pseudo": "Ψευδώνυμο (ορατό δημόσια)",
   "password": "Κωδικός πρόσβασης (τουλάχιστον 6 χαρακτήρες)",
   "elevageOptional": "Τύπος κτηνοτροφίας (προαιρετικό)",
   "createAccount": "Δημιουργία λογαριασμού",
   "alreadyAccount": "Έχετε ήδη λογαριασμό;",
   "newHere": "Νέος εδώ;",
   "switchToLogin": "Σύνδεση",
   "switchToRegister": "Δημιουργία λογαριασμού",
   "newThreadDesc": "Επιλέξτε κατηγορία και περιγράψτε την ερώτησή σας για να ξεκινήσετε τη συζήτηση.",
   "categoryPh": "Κατηγορία…",
   "subcategoryPh": "Υποκατηγορία…",
   "threadTitlePh": "Τίτλος ερώτησης (τουλάχιστον 8 χαρακτήρες)",
   "threadBodyPh": "Περιγράψτε την κατάστασή σας ή την ερώτησή σας…",
   "cancel": "Ακύρωση",
   "toastPending": "Το θέμα δημιουργήθηκε! Θα εμφανιστεί μετά την έγκριση (1ο μήνυμα νέου μέλους).",
   "toastPublished": "Το θέμα δημοσιεύτηκε!",
   "toastReplyPending": "Η απάντησή σας θα εμφανιστεί μετά την έγκριση (1ο μήνυμα).",
   "toastReplyPublished": "Η απάντηση δημοσιεύτηκε!",
   "toastResolvedOn": "Σημάνθηκε ως λυμένο.",
   "toastResolvedOff": "Η σήμανση αφαιρέθηκε.",
   "toastWelcome": "Καλώς ήρθατε στο φόρουμ!",
   "toastConnected": "Συνδεθήκατε!",
   "toastLoggedOut": "Αποσυνδεθήκατε από το φόρουμ.",
   "error": "Σφάλμα",
   "metaIndexTitle": "Φόρουμ Ma Petite Ferme — Αλληλοβοήθεια μεταξύ κτηνοτρόφων",
   "metaIndexDesc": "Κάντε ερωτήσεις για την κτηνοτροφία, την απευθείας πώληση, την τυροκομία, το κρέας και τα αυγά. Κοινότητα κτηνοτρόφων Ma Petite Ferme.",
   "badgeEquipe": "Ομάδα",
   "badgeExpert": "Ειδικός",
   "badgeContrib": "Συνεισφέρων",
   "badgeNew": "Νέος"
  },
  "elevage": {
   "volailles": "Πουλερικά & αυγά",
   "fromage-lait": "Τυρί & γάλα",
   "viande": "Κρέας",
   "maraichage": "Κηπευτικά",
   "autre": "Άλλο"
  },
  "cats": {
   "volailles-oeufs": "Πουλερικά & Αυγά",
   "fromage-lait": "Τυρί & Γάλα",
   "viande": "Κρέας",
   "vente-business": "Πώληση & Επιχείρηση",
   "general-elevage": "Γενική Κτηνοτροφία"
  },
  "subs": {
   "alimentation-sante": "Διατροφή & υγεία",
   "production-ponte": "Παραγωγή & ωοτοκία",
   "materiel-poulailler": "Εξοπλισμός & κοτέτσι",
   "traite-sante": "Άρμεγμα & υγεία ζώων",
   "transformation-affinage": "Μεταποίηση & ωρίμανση",
   "reglementation-hygiene": "Κανονισμοί & υγιεινή",
   "elevage-croissance": "Κτηνοτροφία & ανάπτυξη",
   "abattage-decoupe": "Σφαγή & κοπή",
   "reglementation": "Κανονισμοί",
   "fixer-prix": "Καθορισμός τιμών",
   "vente-directe": "Απευθείας πώληση / κοντινά κυκλώματα",
   "communication": "Επικοινωνία & κοινωνικά δίκτυα",
   "reglementation-declarations": "Κανονισμοί & δηλώσεις",
   "presentation-membres": "Παρουσίαση μελών",
   "suggestions": "Προτάσεις για το Ma Petite Ferme"
  }
 },
 "hr": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Povratak na stranicu",
   "login": "Prijava",
   "logout": "Odjava",
   "heroTitle": "Forum uzgajivača",
   "heroSubtitle": "Pitanja, savjeti i međusobna pomoć između zaljubljenika u uzgoj stoke. Pronađite odgovor ili pokrenite raspravu.",
   "newThread": "Nova tema",
   "searchPlaceholder": "Pretraži temu…",
   "resultsFor": "rezultat(a) za",
   "noResults": "Nije pronađena nijedna tema. Pokušajte s drugim ključnim riječima.",
   "recentDiscussions": "Nedavne rasprave",
   "topMembers": "Najaktivniji članovi",
   "allCategories": "Sve kategorije",
   "subAll": "Sve",
   "sortRecent": "Najnovije",
   "sortUnanswered": "Bez odgovora",
   "sortResolved": "Riješeno",
   "emptyCategory": "Još nema tema. Pokrenite raspravu!",
   "threadOne": "tema",
   "threadMany": "tema",
   "replyOne": "odgovor",
   "replyMany": "odgovora",
   "by": "od",
   "resolved": "Riješeno",
   "markResolved": "Označi kao riješeno",
   "unmarkResolved": "Ukloni oznaku riješeno",
   "pendingModeration": "Ova tema čeka odobrenje moderatora.",
   "yourReply": "Vaš odgovor",
   "replyPlaceholder": "Podijelite svoje iskustvo…",
   "replyPlaceholderGuest": "Prijavite se kako biste odgovorili.",
   "publish": "Objavi",
   "loginToReply": "Prijavi se za odgovor",
   "relatedTopics": "Slične teme",
   "threadNotFound": "Tema nije pronađena.",
   "backToForum": "Povratak na forum",
   "loading": "Učitavanje…",
   "memberNotFound": "Član nije pronađen.",
   "memberSince": "Član od",
   "contributionOne": "doprinos",
   "contributionMany": "doprinosa",
   "memberThreads": "Teme od {name}",
   "memberNoThreads": "Još nije objavljena nijedna tema.",
   "joinForum": "Pridruži se forumu",
   "forumLogin": "Prijava na forum",
   "registerDesc": "Stvorite forumski račun (e-mail, nadimak, lozinka) kako biste sudjelovali.",
   "loginDesc": "Prijavite se s e-mailom i lozinkom.",
   "email": "E-mail",
   "pseudo": "Nadimak (javno vidljiv)",
   "password": "Lozinka (min. 6 znakova)",
   "elevageOptional": "Vrsta uzgoja (neobavezno)",
   "createAccount": "Stvori moj račun",
   "alreadyAccount": "Već imate račun?",
   "newHere": "Novi ste ovdje?",
   "switchToLogin": "Prijavi se",
   "switchToRegister": "Stvori račun",
   "newThreadDesc": "Odaberite kategoriju i opišite svoje pitanje kako biste pokrenuli raspravu.",
   "categoryPh": "Kategorija…",
   "subcategoryPh": "Potkategorija…",
   "threadTitlePh": "Naslov vašeg pitanja (min. 8 znakova)",
   "threadBodyPh": "Opišite svoju situaciju ili pitanje…",
   "cancel": "Odustani",
   "toastPending": "Tema je stvorena! Bit će vidljiva nakon odobrenja (prva objava novog člana).",
   "toastPublished": "Tema je objavljena!",
   "toastReplyPending": "Vaš odgovor bit će vidljiv nakon odobrenja (prva objava).",
   "toastReplyPublished": "Odgovor je objavljen!",
   "toastResolvedOn": "Označeno kao riješeno.",
   "toastResolvedOff": "Oznaka riješeno je uklonjena.",
   "toastWelcome": "Dobrodošli na forum!",
   "toastConnected": "Prijavljeni ste!",
   "toastLoggedOut": "Odjavljeni ste s foruma.",
   "error": "Greška",
   "metaIndexTitle": "Forum Mala Moja Farma — Međusobna pomoć uzgajivača",
   "metaIndexDesc": "Postavite pitanja o uzgoju, izravnoj prodaji, preradi sira, mesu i jajima. Zajednica uzgajivača Mala Moja Farma.",
   "badgeEquipe": "Tim",
   "badgeExpert": "Stručnjak",
   "badgeContrib": "Suradnik",
   "badgeNew": "Novi"
  },
  "elevage": {
   "volailles": "Perad i jaja",
   "fromage-lait": "Sir i mlijeko",
   "viande": "Meso",
   "maraichage": "Povrtlarstvo",
   "autre": "Ostalo"
  },
  "cats": {
   "volailles-oeufs": "Perad i jaja",
   "fromage-lait": "Sir i mlijeko",
   "viande": "Meso",
   "vente-business": "Prodaja i poslovanje",
   "general-elevage": "Općenito o uzgoju"
  },
  "subs": {
   "alimentation-sante": "Prehrana i zdravlje",
   "production-ponte": "Proizvodnja i nesivost",
   "materiel-poulailler": "Oprema i kokošinjac",
   "traite-sante": "Mužnja i zdravlje životinja",
   "transformation-affinage": "Prerada i zrenje",
   "reglementation-hygiene": "Propisi i higijena",
   "elevage-croissance": "Uzgoj i rast",
   "abattage-decoupe": "Klanje i rasijecanje",
   "reglementation": "Propisi",
   "fixer-prix": "Određivanje cijena",
   "vente-directe": "Izravna prodaja / kratki lanci opskrbe",
   "communication": "Komunikacija i društvene mreže",
   "reglementation-declarations": "Propisi i prijave",
   "presentation-membres": "Predstavljanje članova",
   "suggestions": "Prijedlozi za Malu Moju Farmu"
  }
 },
 "et": {
  "ui": {
   "navForum": "Foorum",
   "backToSite": "Tagasi saidile",
   "login": "Logi sisse",
   "logout": "Logi välja",
   "heroTitle": "Loomakasvatajate foorum",
   "heroSubtitle": "Küsimused, nõuanded ja vastastikune abi loomakasvatuse entusiastide vahel. Leia vastus või alusta arutelu.",
   "newThread": "Uus teema",
   "searchPlaceholder": "Otsi teemat…",
   "resultsFor": "tulemus(t) otsingule",
   "noResults": "Ühtegi teemat ei leitud. Proovi teisi märksõnu.",
   "recentDiscussions": "Viimased arutelud",
   "topMembers": "Aktiivsemad liikmed",
   "allCategories": "Kõik kategooriad",
   "subAll": "Kõik",
   "sortRecent": "Uusimad",
   "sortUnanswered": "Vastamata",
   "sortResolved": "Lahendatud",
   "emptyCategory": "Praegu pole ühtegi teemat. Alusta arutelu!",
   "threadOne": "teema",
   "threadMany": "teemat",
   "replyOne": "vastus",
   "replyMany": "vastust",
   "by": "autor",
   "resolved": "Lahendatud",
   "markResolved": "Märgi lahendatuks",
   "unmarkResolved": "Eemalda lahendatud",
   "pendingModeration": "See teema ootab moderaatori kinnitust.",
   "yourReply": "Sinu vastus",
   "replyPlaceholder": "Jaga oma kogemust…",
   "replyPlaceholderGuest": "Vastamiseks logi sisse.",
   "publish": "Avalda",
   "loginToReply": "Logi sisse vastamiseks",
   "relatedTopics": "Sarnased teemad",
   "threadNotFound": "Teemat ei leitud.",
   "backToForum": "Tagasi foorumisse",
   "loading": "Laadimine…",
   "memberNotFound": "Liiget ei leitud.",
   "memberSince": "Liige alates",
   "contributionOne": "panus",
   "contributionMany": "panust",
   "memberThreads": "{name} teemad",
   "memberNoThreads": "Ühtegi teemat pole veel avaldatud.",
   "joinForum": "Liitu foorumiga",
   "forumLogin": "Foorum – sisselogimine",
   "registerDesc": "Loo foorumikonto (e-post, kasutajanimi, parool), et osaleda aruteludes.",
   "loginDesc": "Logi sisse oma e-posti ja parooliga.",
   "email": "E-post",
   "pseudo": "Kasutajanimi (avalikult nähtav)",
   "password": "Parool (vähemalt 6 tähemärki)",
   "elevageOptional": "Loomakasvatuse liik (valikuline)",
   "createAccount": "Loo konto",
   "alreadyAccount": "Kas sul on juba konto?",
   "newHere": "Uus kasutaja?",
   "switchToLogin": "Logi sisse",
   "switchToRegister": "Loo konto",
   "newThreadDesc": "Vali kategooria ja kirjelda oma küsimust, et arutelu käivitada.",
   "categoryPh": "Kategooria…",
   "subcategoryPh": "Alamkategooria…",
   "threadTitlePh": "Sinu küsimuse pealkiri (vähemalt 8 tähemärki)",
   "threadBodyPh": "Kirjelda oma olukorda või küsimust…",
   "cancel": "Tühista",
   "toastPending": "Teema loodud! See kuvatakse pärast kinnitamist (uue liikme esimene sõnum).",
   "toastPublished": "Teema avaldatud!",
   "toastReplyPending": "Sinu vastus kuvatakse pärast kinnitamist (esimene sõnum).",
   "toastReplyPublished": "Vastus avaldatud!",
   "toastResolvedOn": "Märgitud lahendatuks.",
   "toastResolvedOff": "Lahendatud märge eemaldatud.",
   "toastWelcome": "Tere tulemast foorumisse!",
   "toastConnected": "Sisse logitud!",
   "toastLoggedOut": "Foorumist välja logitud.",
   "error": "Viga",
   "metaIndexTitle": "Ma Petite Ferme foorum — Loomakasvatajate kogukond",
   "metaIndexDesc": "Esita küsimusi loomakasvatuse, otseturustuse, juustutootmise, liha ja munade kohta. Ma Petite Ferme loomakasvatajate kogukond.",
   "badgeEquipe": "Meeskond",
   "badgeExpert": "Ekspert",
   "badgeContrib": "Kaastöötaja",
   "badgeNew": "Uus"
  },
  "elevage": {
   "volailles": "Linnud ja munad",
   "fromage-lait": "Juust ja piim",
   "viande": "Liha",
   "maraichage": "Köögiviljandus",
   "autre": "Muu"
  },
  "cats": {
   "volailles-oeufs": "Linnud ja munad",
   "fromage-lait": "Juust ja piim",
   "viande": "Liha",
   "vente-business": "Müük ja ettevõtlus",
   "general-elevage": "Loomakasvatuse üldteemad"
  },
  "subs": {
   "alimentation-sante": "Toitumine ja tervis",
   "production-ponte": "Toodang ja munemine",
   "materiel-poulailler": "Varustus ja kanalad",
   "traite-sante": "Lüpsmine ja loomade tervis",
   "transformation-affinage": "Töötlemine ja laagerdamine",
   "reglementation-hygiene": "Eeskirjad ja hügieen",
   "elevage-croissance": "Kasvatus ja kasv",
   "abattage-decoupe": "Tapmine ja lihalõikus",
   "reglementation": "Eeskirjad",
   "fixer-prix": "Hindade kujundamine",
   "vente-directe": "Otseturustus ja lühikesed tarneahelad",
   "communication": "Suhtlus ja sotsiaalmeedia",
   "reglementation-declarations": "Eeskirjad ja deklaratsioonid",
   "presentation-membres": "Liikmete tutvustused",
   "suggestions": "Ettepanekud Ma Petite Ferme'ile"
  }
 },
 "fi": {
  "ui": {
   "navForum": "Foorumi",
   "backToSite": "Takaisin sivustolle",
   "login": "Kirjaudu sisään",
   "logout": "Kirjaudu ulos",
   "heroTitle": "Kasvattajien foorumi",
   "heroSubtitle": "Kysymyksiä, neuvoja ja vertaistukea kotieläinharrastajille. Löydä vastaus tai aloita keskustelu.",
   "newThread": "Uusi aihe",
   "searchPlaceholder": "Etsi aihetta…",
   "resultsFor": "tulos(ta) haulle",
   "noResults": "Aiheita ei löytynyt. Kokeile eri hakusanoja.",
   "recentDiscussions": "Viimeisimmät keskustelut",
   "topMembers": "Aktiivisimmat jäsenet",
   "allCategories": "Kaikki kategoriat",
   "subAll": "Kaikki",
   "sortRecent": "Uusimmat",
   "sortUnanswered": "Vastaamattomat",
   "sortResolved": "Ratkaistut",
   "emptyCategory": "Ei aiheita vielä. Aloita keskustelu!",
   "threadOne": "aihe",
   "threadMany": "aihetta",
   "replyOne": "vastaus",
   "replyMany": "vastausta",
   "by": "kirjoittanut",
   "resolved": "Ratkaistu",
   "markResolved": "Merkitse ratkaistuksi",
   "unmarkResolved": "Poista ratkaistu-merkintä",
   "pendingModeration": "Tämä aihe odottaa moderaattorin hyväksyntää.",
   "yourReply": "Vastauksesi",
   "replyPlaceholder": "Jaa kokemuksesi…",
   "replyPlaceholderGuest": "Kirjaudu sisään vastataksesi.",
   "publish": "Julkaise",
   "loginToReply": "Kirjaudu sisään vastataksesi",
   "relatedTopics": "Samankaltaiset aiheet",
   "threadNotFound": "Aihetta ei löydy.",
   "backToForum": "Takaisin foorumille",
   "loading": "Ladataan…",
   "memberNotFound": "Jäsentä ei löydy.",
   "memberSince": "Jäsen alkaen",
   "contributionOne": "viesti",
   "contributionMany": "viestiä",
   "memberThreads": "Käyttäjän {name} aiheet",
   "memberNoThreads": "Ei julkaistuja aiheita vielä.",
   "joinForum": "Liity foorumille",
   "forumLogin": "Kirjaudu foorumille",
   "registerDesc": "Luo foorumitili (sähköposti, nimimerkki, salasana) osallistuaksesi.",
   "loginDesc": "Kirjaudu sisään sähköpostillasi ja salasanallasi.",
   "email": "Sähköposti",
   "pseudo": "Nimimerkki (näkyy julkisesti)",
   "password": "Salasana (väh. 6 merkkiä)",
   "elevageOptional": "Eläintyyppi (valinnainen)",
   "createAccount": "Luo tili",
   "alreadyAccount": "Onko sinulla jo tili?",
   "newHere": "Uusi jäsen?",
   "switchToLogin": "Kirjaudu sisään",
   "switchToRegister": "Luo tili",
   "newThreadDesc": "Valitse kategoria ja kuvaile kysymyksesi aloittaaksesi keskustelun.",
   "categoryPh": "Kategoria…",
   "subcategoryPh": "Alakategoria…",
   "threadTitlePh": "Kysymyksesi otsikko (väh. 8 merkkiä)",
   "threadBodyPh": "Kuvaile tilannettasi tai kysymystäsi…",
   "cancel": "Peruuta",
   "toastPending": "Aihe luotu! Se tulee näkyviin hyväksynnän jälkeen (uuden jäsenen ensimmäinen viesti).",
   "toastPublished": "Aihe julkaistu!",
   "toastReplyPending": "Vastauksesi tulee näkyviin hyväksynnän jälkeen (ensimmäinen viesti).",
   "toastReplyPublished": "Vastaus julkaistu!",
   "toastResolvedOn": "Merkitty ratkaistuksi.",
   "toastResolvedOff": "Ratkaistu-merkintä poistettu.",
   "toastWelcome": "Tervetuloa foorumille!",
   "toastConnected": "Kirjauduttu sisään!",
   "toastLoggedOut": "Kirjauduttu ulos foorumilta.",
   "error": "Virhe",
   "metaIndexTitle": "Ma Petite Ferme -foorumi — Kasvattajien vertaistuki",
   "metaIndexDesc": "Kysy neuvoa eläintenkasvatuksesta, suoramyynnistä, juustonvalmistuksesta, lihasta ja munista. Ma Petite Ferme -kasvattajayhteisö.",
   "badgeEquipe": "Tiimi",
   "badgeExpert": "Asiantuntija",
   "badgeContrib": "Aktiivinen jäsen",
   "badgeNew": "Uusi jäsen"
  },
  "elevage": {
   "volailles": "Siipikarja & munat",
   "fromage-lait": "Juusto & maito",
   "viande": "Liha",
   "maraichage": "Vihannesviljely",
   "autre": "Muu"
  },
  "cats": {
   "volailles-oeufs": "Siipikarja & munat",
   "fromage-lait": "Juusto & maito",
   "viande": "Liha",
   "vente-business": "Myynti & liiketoiminta",
   "general-elevage": "Yleinen kasvatus"
  },
  "subs": {
   "alimentation-sante": "Ravitsemus & terveys",
   "production-ponte": "Tuotanto & muninta",
   "materiel-poulailler": "Laitteet & kanala",
   "traite-sante": "Lypsy & eläinterveys",
   "transformation-affinage": "Jalostus & kypsytys",
   "reglementation-hygiene": "Säädökset & hygienia",
   "elevage-croissance": "Kasvatus & kasvu",
   "abattage-decoupe": "Teurastus & leikkaus",
   "reglementation": "Säädökset",
   "fixer-prix": "Hinnoittelu",
   "vente-directe": "Suoramyynti / lyhyet toimitusketjut",
   "communication": "Viestintä & sosiaalinen media",
   "reglementation-declarations": "Säädökset & ilmoitukset",
   "presentation-membres": "Jäsenten esittely",
   "suggestions": "Ehdotukset Ma Petite Fermelle"
  }
 },
 "pl": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Powrót do strony",
   "login": "Zaloguj się",
   "logout": "Wyloguj się",
   "heroTitle": "Forum hodowców",
   "heroSubtitle": "Pytania, porady i wzajemna pomoc między pasjonatami hodowli. Znajdź odpowiedź lub rozpocznij dyskusję.",
   "newThread": "Nowy temat",
   "searchPlaceholder": "Szukaj tematu…",
   "resultsFor": "wynik(ów) dla",
   "noResults": "Nie znaleziono tematów. Spróbuj innych słów kluczowych.",
   "recentDiscussions": "Ostatnie dyskusje",
   "topMembers": "Najbardziej aktywni członkowie",
   "allCategories": "Wszystkie kategorie",
   "subAll": "Wszystkie",
   "sortRecent": "Najnowsze",
   "sortUnanswered": "Bez odpowiedzi",
   "sortResolved": "Rozwiązane",
   "emptyCategory": "Brak tematów na razie. Rozpocznij dyskusję!",
   "threadOne": "temat",
   "threadMany": "tematy",
   "replyOne": "odpowiedź",
   "replyMany": "odpowiedzi",
   "by": "przez",
   "resolved": "Rozwiązany",
   "markResolved": "Oznacz jako rozwiązany",
   "unmarkResolved": "Usuń oznaczenie rozwiązany",
   "pendingModeration": "Ten temat oczekuje na zatwierdzenie przez moderację.",
   "yourReply": "Twoja odpowiedź",
   "replyPlaceholder": "Podziel się swoim doświadczeniem…",
   "replyPlaceholderGuest": "Zaloguj się, aby odpowiedzieć.",
   "publish": "Opublikuj",
   "loginToReply": "Zaloguj się, aby odpowiedzieć",
   "relatedTopics": "Podobne tematy",
   "threadNotFound": "Temat nie został znaleziony.",
   "backToForum": "Powrót do forum",
   "loading": "Ładowanie…",
   "memberNotFound": "Członek nie został znaleziony.",
   "memberSince": "Członek od",
   "contributionOne": "wpis",
   "contributionMany": "wpisy",
   "memberThreads": "Tematy użytkownika {name}",
   "memberNoThreads": "Brak opublikowanych tematów na razie.",
   "joinForum": "Dołącz do forum",
   "forumLogin": "Logowanie do forum",
   "registerDesc": "Utwórz konto na forum (e-mail, pseudonim, hasło), aby uczestniczyć w dyskusjach.",
   "loginDesc": "Zaloguj się za pomocą swojego adresu e-mail i hasła.",
   "email": "E-mail",
   "pseudo": "Pseudonim (widoczny publicznie)",
   "password": "Hasło (min. 6 znaków)",
   "elevageOptional": "Rodzaj hodowli (opcjonalnie)",
   "createAccount": "Utwórz konto",
   "alreadyAccount": "Masz już konto?",
   "newHere": "Nowy użytkownik?",
   "switchToLogin": "Zaloguj się",
   "switchToRegister": "Utwórz konto",
   "newThreadDesc": "Wybierz kategorię i opisz swoje pytanie, aby rozpocząć dyskusję.",
   "categoryPh": "Kategoria…",
   "subcategoryPh": "Podkategoria…",
   "threadTitlePh": "Tytuł Twojego pytania (min. 8 znaków)",
   "threadBodyPh": "Opisz swoją sytuację lub pytanie…",
   "cancel": "Anuluj",
   "toastPending": "Temat utworzony! Będzie widoczny po zatwierdzeniu (pierwsza wiadomość nowego członka).",
   "toastPublished": "Temat opublikowany!",
   "toastReplyPending": "Twoja odpowiedź będzie widoczna po zatwierdzeniu (pierwsza wiadomość).",
   "toastReplyPublished": "Odpowiedź opublikowana!",
   "toastResolvedOn": "Oznaczono jako rozwiązany.",
   "toastResolvedOff": "Usunięto oznaczenie rozwiązany.",
   "toastWelcome": "Witaj na forum!",
   "toastConnected": "Zalogowano!",
   "toastLoggedOut": "Wylogowano z forum.",
   "error": "Błąd",
   "metaIndexTitle": "Forum Ma Petite Ferme — Wzajemna pomoc między hodowcami",
   "metaIndexDesc": "Zadawaj pytania dotyczące hodowli, sprzedaży bezpośredniej, wyrobu serów, mięsa i jaj. Społeczność hodowców Ma Petite Ferme.",
   "badgeEquipe": "Zespół",
   "badgeExpert": "Ekspert",
   "badgeContrib": "Współtwórca",
   "badgeNew": "Nowy"
  },
  "elevage": {
   "volailles": "Drób i jaja",
   "fromage-lait": "Sery i mleko",
   "viande": "Mięso",
   "maraichage": "Warzywnictwo",
   "autre": "Inne"
  },
  "cats": {
   "volailles-oeufs": "Drób i jaja",
   "fromage-lait": "Sery i mleko",
   "viande": "Mięso",
   "vente-business": "Sprzedaż i biznes",
   "general-elevage": "Hodowla ogólna"
  },
  "subs": {
   "alimentation-sante": "Żywienie i zdrowie",
   "production-ponte": "Produkcja i nieśność",
   "materiel-poulailler": "Sprzęt i kurnik",
   "traite-sante": "Dój i zdrowie zwierząt",
   "transformation-affinage": "Przetwórstwo i dojrzewanie",
   "reglementation-hygiene": "Przepisy i higiena",
   "elevage-croissance": "Hodowla i wzrost",
   "abattage-decoupe": "Ubój i rozbiór",
   "reglementation": "Przepisy prawne",
   "fixer-prix": "Ustalanie cen",
   "vente-directe": "Sprzedaż bezpośrednia / krótkie łańcuchy dostaw",
   "communication": "Komunikacja i media społecznościowe",
   "reglementation-declarations": "Przepisy i zgłoszenia",
   "presentation-membres": "Przedstawienie się członków",
   "suggestions": "Sugestie dla Ma Petite Ferme"
  }
 },
 "bg": {
  "ui": {
   "navForum": "Форум",
   "backToSite": "Обратно към сайта",
   "login": "Влезте",
   "logout": "Излезте",
   "heroTitle": "Форум на животновъдите",
   "heroSubtitle": "Въпроси, съвети и взаимопомощ между страстни животновъди. Намерете отговор или започнете дискусия.",
   "newThread": "Нова тема",
   "searchPlaceholder": "Търсене на тема…",
   "resultsFor": "резултат(и) за",
   "noResults": "Няма намерени теми. Опитайте с други ключови думи.",
   "recentDiscussions": "Последни дискусии",
   "topMembers": "Най-активни членове",
   "allCategories": "Всички категории",
   "subAll": "Всички",
   "sortRecent": "Последни",
   "sortUnanswered": "Без отговор",
   "sortResolved": "Решени",
   "emptyCategory": "Все още няма теми. Започнете дискусията!",
   "threadOne": "тема",
   "threadMany": "теми",
   "replyOne": "отговор",
   "replyMany": "отговора",
   "by": "от",
   "resolved": "Решено",
   "markResolved": "Маркирай като решено",
   "unmarkResolved": "Премахни решено",
   "pendingModeration": "Тази тема чака одобрение от модерацията.",
   "yourReply": "Вашият отговор",
   "replyPlaceholder": "Споделете своя опит…",
   "replyPlaceholderGuest": "Влезте в профила си, за да отговорите.",
   "publish": "Публикувай",
   "loginToReply": "Влезте, за да отговорите",
   "relatedTopics": "Подобни теми",
   "threadNotFound": "Темата не е намерена.",
   "backToForum": "Обратно към форума",
   "loading": "Зареждане…",
   "memberNotFound": "Членът не е намерен.",
   "memberSince": "Член от",
   "contributionOne": "принос",
   "contributionMany": "приноса",
   "memberThreads": "Теми на {name}",
   "memberNoThreads": "Все още няма публикувани теми.",
   "joinForum": "Присъединете се към форума",
   "forumLogin": "Вход във форума",
   "registerDesc": "Създайте форумен акаунт (имейл, псевдоним, парола), за да участвате.",
   "loginDesc": "Влезте с вашия имейл и парола.",
   "email": "Имейл",
   "pseudo": "Псевдоним (публично видим)",
   "password": "Парола (минимум 6 символа)",
   "elevageOptional": "Вид животновъдство (по избор)",
   "createAccount": "Създай акаунт",
   "alreadyAccount": "Вече имате акаунт?",
   "newHere": "Нов потребител?",
   "switchToLogin": "Влезте",
   "switchToRegister": "Създайте акаунт",
   "newThreadDesc": "Изберете категория и опишете въпроса си, за да започнете дискусията.",
   "categoryPh": "Категория…",
   "subcategoryPh": "Подкатегория…",
   "threadTitlePh": "Заглавие на въпроса ви (минимум 8 символа)",
   "threadBodyPh": "Опишете вашата ситуация или въпрос…",
   "cancel": "Отказ",
   "toastPending": "Темата е създадена! Ще бъде видима след одобрение (първо съобщение на нов член).",
   "toastPublished": "Темата е публикувана!",
   "toastReplyPending": "Вашият отговор ще бъде видим след одобрение (първо съобщение).",
   "toastReplyPublished": "Отговорът е публикуван!",
   "toastResolvedOn": "Маркирано като решено.",
   "toastResolvedOff": "Решено е премахнато.",
   "toastWelcome": "Добре дошли във форума!",
   "toastConnected": "Влязохте успешно!",
   "toastLoggedOut": "Излязохте от форума.",
   "error": "Грешка",
   "metaIndexTitle": "Форум Моята малка ферма — Взаимопомощ между животновъди",
   "metaIndexDesc": "Задавайте въпроси за животновъдство, директна продажба, сирена, месо и яйца. Общност на животновъдите Моята малка ферма.",
   "badgeEquipe": "Екип",
   "badgeExpert": "Експерт",
   "badgeContrib": "Сътрудник",
   "badgeNew": "Нов"
  },
  "elevage": {
   "volailles": "Птици & яйца",
   "fromage-lait": "Сирене & мляко",
   "viande": "Месо",
   "maraichage": "Зеленчукопроизводство",
   "autre": "Друго"
  },
  "cats": {
   "volailles-oeufs": "Птици & Яйца",
   "fromage-lait": "Сирене & Мляко",
   "viande": "Месо",
   "vente-business": "Продажба & Бизнес",
   "general-elevage": "Общо животновъдство"
  },
  "subs": {
   "alimentation-sante": "Хранене & здраве",
   "production-ponte": "Производство & носливост",
   "materiel-poulailler": "Оборудване & кокошарник",
   "traite-sante": "Доене & здраве на животните",
   "transformation-affinage": "Преработка & зреене",
   "reglementation-hygiene": "Регулации & хигиена",
   "elevage-croissance": "Отглеждане & растеж",
   "abattage-decoupe": "Клане & разфасовка",
   "reglementation": "Регулации",
   "fixer-prix": "Определяне на цени",
   "vente-directe": "Директна продажба / къси вериги",
   "communication": "Комуникация & социални мрежи",
   "reglementation-declarations": "Регулации & декларации",
   "presentation-membres": "Представяне на членовете",
   "suggestions": "Предложения за Моята малка ферма"
  }
 },
 "hu": {
  "ui": {
   "navForum": "Fórum",
   "backToSite": "Vissza a weboldalra",
   "login": "Bejelentkezés",
   "logout": "Kijelentkezés",
   "heroTitle": "Állattartók fóruma",
   "heroSubtitle": "Kérdések, tanácsok és kölcsönös segítség állattartás-rajongók között. Találj választ, vagy indíts új témát.",
   "newThread": "Új téma",
   "searchPlaceholder": "Téma keresése…",
   "resultsFor": "találat erre:",
   "noResults": "Nem található téma. Próbálj más kulcsszavakat.",
   "recentDiscussions": "Legújabb beszélgetések",
   "topMembers": "Legaktívabb tagok",
   "allCategories": "Összes kategória",
   "subAll": "Összes",
   "sortRecent": "Legújabb",
   "sortUnanswered": "Megválaszolatlan",
   "sortResolved": "Megoldott",
   "emptyCategory": "Még nincs téma. Indítsd el a beszélgetést!",
   "threadOne": "téma",
   "threadMany": "téma",
   "replyOne": "válasz",
   "replyMany": "válasz",
   "by": "írta:",
   "resolved": "Megoldva",
   "markResolved": "Megoldottnak jelölés",
   "unmarkResolved": "Megoldás visszavonása",
   "pendingModeration": "Ez a téma moderátori jóváhagyásra vár.",
   "yourReply": "A te válaszod",
   "replyPlaceholder": "Oszd meg a tapasztalataidat…",
   "replyPlaceholderGuest": "A válaszhoz jelentkezz be.",
   "publish": "Közzététel",
   "loginToReply": "Bejelentkezés a válaszhoz",
   "relatedTopics": "Hasonló témák",
   "threadNotFound": "A téma nem található.",
   "backToForum": "Vissza a fórumra",
   "loading": "Betöltés…",
   "memberNotFound": "A tag nem található.",
   "memberSince": "Tag azóta:",
   "contributionOne": "hozzászólás",
   "contributionMany": "hozzászólás",
   "memberThreads": "{name} témái",
   "memberNoThreads": "Még nem tett közzé témát.",
   "joinForum": "Csatlakozás a fórumhoz",
   "forumLogin": "Bejelentkezés a fórumba",
   "registerDesc": "Hozz létre egy fórum fiókot (email, becenév, jelszó) a részvételhez.",
   "loginDesc": "Jelentkezz be az email címeddel és jelszavaddal.",
   "email": "E-mail",
   "pseudo": "Becenév (nyilvánosan látható)",
   "password": "Jelszó (min. 6 karakter)",
   "elevageOptional": "Állattartás típusa (opcionális)",
   "createAccount": "Fiók létrehozása",
   "alreadyAccount": "Már van fiókod?",
   "newHere": "Új vagy?",
   "switchToLogin": "Bejelentkezés",
   "switchToRegister": "Fiók létrehozása",
   "newThreadDesc": "Válassz kategóriát és írd le a kérdésedet a beszélgetés elindításához.",
   "categoryPh": "Kategória…",
   "subcategoryPh": "Alkategória…",
   "threadTitlePh": "A kérdésed címe (min. 8 karakter)",
   "threadBodyPh": "Írd le a helyzetedet vagy a kérdésedet…",
   "cancel": "Mégse",
   "toastPending": "Téma létrehozva! Jóváhagyás után lesz látható (új tag első hozzászólása).",
   "toastPublished": "Téma közzétéve!",
   "toastReplyPending": "A válaszod jóváhagyás után lesz látható (első hozzászólás).",
   "toastReplyPublished": "Válasz közzétéve!",
   "toastResolvedOn": "Megoldottnak jelölve.",
   "toastResolvedOff": "Megoldás visszavonva.",
   "toastWelcome": "Üdvözlünk a fórumon!",
   "toastConnected": "Bejelentkezve!",
   "toastLoggedOut": "Kijelentkezve a fórumból.",
   "error": "Hiba",
   "metaIndexTitle": "Ma Petite Ferme Fórum — Állattartók közösségi segítsége",
   "metaIndexDesc": "Tedd fel kérdéseidet az állattartásról, a közvetlen értékesítésről, a sajtkészítésről, a húsról és a tojásról. A Ma Petite Ferme állattartói közössége.",
   "badgeEquipe": "Csapat",
   "badgeExpert": "Szakértő",
   "badgeContrib": "Közreműködő",
   "badgeNew": "Új tag"
  },
  "elevage": {
   "volailles": "Baromfi & tojás",
   "fromage-lait": "Sajt & tej",
   "viande": "Hús",
   "maraichage": "Zöldségtermesztés",
   "autre": "Egyéb"
  },
  "cats": {
   "volailles-oeufs": "Baromfi & Tojás",
   "fromage-lait": "Sajt & Tej",
   "viande": "Hús",
   "vente-business": "Értékesítés & Üzlet",
   "general-elevage": "Általános állattartás"
  },
  "subs": {
   "alimentation-sante": "Takarmányozás & egészség",
   "production-ponte": "Termelés & tojáshozam",
   "materiel-poulailler": "Felszerelés & tyúkól",
   "traite-sante": "Fejés & állategészség",
   "transformation-affinage": "Feldolgozás & érlelés",
   "reglementation-hygiene": "Szabályozás & higiénia",
   "elevage-croissance": "Tenyésztés & növekedés",
   "abattage-decoupe": "Vágás & darabolás",
   "reglementation": "Szabályozás",
   "fixer-prix": "Árak meghatározása",
   "vente-directe": "Közvetlen értékesítés / rövid láncok",
   "communication": "Kommunikáció & közösségi média",
   "reglementation-declarations": "Szabályozás & bejelentések",
   "presentation-membres": "Tagok bemutatkozása",
   "suggestions": "Javaslatok a Ma Petite Ferme-nek"
  }
 },
 "lt": {
  "ui": {
   "navForum": "Forumas",
   "backToSite": "Grįžti į svetainę",
   "login": "Prisijungti",
   "logout": "Atsijungti",
   "heroTitle": "Augintojų forumas",
   "heroSubtitle": "Klausimai, patarimai ir savitarpio pagalba tarp gyvulininkystės entuziastų. Raskite atsakymą arba pradėkite diskusiją.",
   "newThread": "Nauja tema",
   "searchPlaceholder": "Ieškoti temos…",
   "resultsFor": "rezultatas(-ai) pagal",
   "noResults": "Temų nerasta. Pabandykite kitus raktažodžius.",
   "recentDiscussions": "Naujausios diskusijos",
   "topMembers": "Aktyviausi nariai",
   "allCategories": "Visos kategorijos",
   "subAll": "Visos",
   "sortRecent": "Naujausi",
   "sortUnanswered": "Be atsakymo",
   "sortResolved": "Išspręsti",
   "emptyCategory": "Kol kas nėra temų. Pradėkite diskusiją!",
   "threadOne": "tema",
   "threadMany": "temos",
   "replyOne": "atsakymas",
   "replyMany": "atsakymai",
   "by": "autorius",
   "resolved": "Išspręsta",
   "markResolved": "Pažymėti kaip išspręstą",
   "unmarkResolved": "Atžymėti kaip išspręstą",
   "pendingModeration": "Ši tema laukia moderatorių patvirtinimo.",
   "yourReply": "Jūsų atsakymas",
   "replyPlaceholder": "Pasidalinkite savo patirtimi…",
   "replyPlaceholderGuest": "Prisijunkite, kad galėtumėte atsakyti.",
   "publish": "Paskelbti",
   "loginToReply": "Prisijungti ir atsakyti",
   "relatedTopics": "Panašios temos",
   "threadNotFound": "Tema nerasta.",
   "backToForum": "Grįžti į forumą",
   "loading": "Kraunama…",
   "memberNotFound": "Narys nerastas.",
   "memberSince": "Narys nuo",
   "contributionOne": "įnašas",
   "contributionMany": "įnašai",
   "memberThreads": "{name} temos",
   "memberNoThreads": "Kol kas nepaskelbta jokių temų.",
   "joinForum": "Prisijungti prie forumo",
   "forumLogin": "Prisijungimas prie forumo",
   "registerDesc": "Susikurkite forumo paskyrą (el. paštas, slapyvardis, slaptažodis), kad galėtumėte dalyvauti.",
   "loginDesc": "Prisijunkite su savo el. paštu ir slaptažodžiu.",
   "email": "El. paštas",
   "pseudo": "Slapyvardis (matomas viešai)",
   "password": "Slaptažodis (min. 6 simboliai)",
   "elevageOptional": "Ūkio tipas (neprivaloma)",
   "createAccount": "Sukurti paskyrą",
   "alreadyAccount": "Jau turite paskyrą?",
   "newHere": "Naujokas?",
   "switchToLogin": "Prisijungti",
   "switchToRegister": "Sukurti paskyrą",
   "newThreadDesc": "Pasirinkite kategoriją ir aprašykite savo klausimą, kad pradėtumėte diskusiją.",
   "categoryPh": "Kategorija…",
   "subcategoryPh": "Subkategorija…",
   "threadTitlePh": "Jūsų klausimo pavadinimas (min. 8 simboliai)",
   "threadBodyPh": "Aprašykite savo situaciją arba klausimą…",
   "cancel": "Atšaukti",
   "toastPending": "Tema sukurta! Ji bus matoma po patvirtinimo (pirmas naujo nario pranešimas).",
   "toastPublished": "Tema paskelbta!",
   "toastReplyPending": "Jūsų atsakymas bus matomas po patvirtinimo (pirmas pranešimas).",
   "toastReplyPublished": "Atsakymas paskelbtas!",
   "toastResolvedOn": "Pažymėta kaip išspręsta.",
   "toastResolvedOff": "Išspręstos žyma pašalinta.",
   "toastWelcome": "Sveiki atvykę į forumą!",
   "toastConnected": "Prisijungta!",
   "toastLoggedOut": "Atsijungta nuo forumo.",
   "error": "Klaida",
   "metaIndexTitle": "Ma Petite Ferme forumas — Augintojų savitarpio pagalba",
   "metaIndexDesc": "Užduokite klausimus apie gyvulininkystę, tiesioginį pardavimą, sūrių gamybą, mėsą ir kiaušinius. Ma Petite Ferme augintojų bendruomenė.",
   "badgeEquipe": "Komanda",
   "badgeExpert": "Ekspertas",
   "badgeContrib": "Prisidėjęs",
   "badgeNew": "Naujokas"
  },
  "elevage": {
   "volailles": "Paukštiena ir kiaušiniai",
   "fromage-lait": "Sūris ir pienas",
   "viande": "Mėsa",
   "maraichage": "Daržininkystė",
   "autre": "Kita"
  },
  "cats": {
   "volailles-oeufs": "Paukštiena ir kiaušiniai",
   "fromage-lait": "Sūris ir pienas",
   "viande": "Mėsa",
   "vente-business": "Pardavimas ir verslas",
   "general-elevage": "Bendroji gyvulininkystė"
  },
  "subs": {
   "alimentation-sante": "Mityba ir sveikata",
   "production-ponte": "Gamyba ir dėjimas",
   "materiel-poulailler": "Įranga ir vištidė",
   "traite-sante": "Melžimas ir gyvūnų sveikata",
   "transformation-affinage": "Perdirbimas ir brandinimas",
   "reglementation-hygiene": "Reglamentai ir higiena",
   "elevage-croissance": "Auginimas ir augimas",
   "abattage-decoupe": "Skerdimas ir pjaustymas",
   "reglementation": "Reglamentai",
   "fixer-prix": "Kainų nustatymas",
   "vente-directe": "Tiesioginis pardavimas / trumpos tiekimo grandinės",
   "communication": "Komunikacija ir socialiniai tinklai",
   "reglementation-declarations": "Reglamentai ir deklaracijos",
   "presentation-membres": "Narių pristatymai",
   "suggestions": "Pasiūlymai Ma Petite Ferme"
  }
 },
 "lv": {
  "ui": {
   "navForum": "Forums",
   "backToSite": "Atpakaļ uz vietni",
   "login": "Pieslēgties",
   "logout": "Atslēgties",
   "heroTitle": "Lopkopju forums",
   "heroSubtitle": "Jautājumi, padomi un savstarpēja palīdzība starp lopkopības entuziastiem. Atrodiet atbildi vai uzsāciet diskusiju.",
   "newThread": "Jauna tēma",
   "searchPlaceholder": "Meklēt tēmu…",
   "resultsFor": "rezultāts(-i) meklējumam",
   "noResults": "Neviena tēma nav atrasta. Mēģiniet citus atslēgvārdus.",
   "recentDiscussions": "Jaunākās diskusijas",
   "topMembers": "Aktīvākie dalībnieki",
   "allCategories": "Visas kategorijas",
   "subAll": "Visas",
   "sortRecent": "Jaunākās",
   "sortUnanswered": "Bez atbildes",
   "sortResolved": "Atrisinātas",
   "emptyCategory": "Pagaidām nav nevienas tēmas. Uzsāciet diskusiju!",
   "threadOne": "tēma",
   "threadMany": "tēmas",
   "replyOne": "atbilde",
   "replyMany": "atbildes",
   "by": "autors",
   "resolved": "Atrisināts",
   "markResolved": "Atzīmēt kā atrisinātu",
   "unmarkResolved": "Noņemt atrisināto",
   "pendingModeration": "Šī tēma gaida moderatoru apstiprinājumu.",
   "yourReply": "Jūsu atbilde",
   "replyPlaceholder": "Dalieties savā pieredzē…",
   "replyPlaceholderGuest": "Pieslēdzieties, lai atbildētu.",
   "publish": "Publicēt",
   "loginToReply": "Pieslēgties, lai atbildētu",
   "relatedTopics": "Līdzīgas tēmas",
   "threadNotFound": "Tēma nav atrasta.",
   "backToForum": "Atpakaļ uz forumu",
   "loading": "Ielādē…",
   "memberNotFound": "Dalībnieks nav atrasts.",
   "memberSince": "Dalībnieks kopš",
   "contributionOne": "ieguldījums",
   "contributionMany": "ieguldījumi",
   "memberThreads": "{name} tēmas",
   "memberNoThreads": "Pagaidām nav publicētu tēmu.",
   "joinForum": "Pievienoties forumam",
   "forumLogin": "Pieslēgšanās forumam",
   "registerDesc": "Izveidojiet foruma kontu (e-pasts, lietotājvārds, parole), lai piedalītos.",
   "loginDesc": "Pieslēdzieties ar savu e-pastu un paroli.",
   "email": "E-pasts",
   "pseudo": "Lietotājvārds (redzams publiski)",
   "password": "Parole (min. 6 rakstzīmes)",
   "elevageOptional": "Lopkopības veids (neobligāti)",
   "createAccount": "Izveidot kontu",
   "alreadyAccount": "Jau ir konts?",
   "newHere": "Jauns šeit?",
   "switchToLogin": "Pieslēgties",
   "switchToRegister": "Izveidot kontu",
   "newThreadDesc": "Izvēlieties kategoriju un aprakstiet savu jautājumu, lai uzsāktu diskusiju.",
   "categoryPh": "Kategorija…",
   "subcategoryPh": "Apakškategorija…",
   "threadTitlePh": "Jūsu jautājuma virsraksts (min. 8 rakstzīmes)",
   "threadBodyPh": "Aprakstiet savu situāciju vai jautājumu…",
   "cancel": "Atcelt",
   "toastPending": "Tēma izveidota! Tā būs redzama pēc apstiprināšanas (jaunā dalībnieka 1. ziņojums).",
   "toastPublished": "Tēma publicēta!",
   "toastReplyPending": "Jūsu atbilde būs redzama pēc apstiprināšanas (1. ziņojums).",
   "toastReplyPublished": "Atbilde publicēta!",
   "toastResolvedOn": "Atzīmēts kā atrisināts.",
   "toastResolvedOff": "Atrisinātais noņemts.",
   "toastWelcome": "Laipni lūdzam forumā!",
   "toastConnected": "Pieslēgts!",
   "toastLoggedOut": "Atslēgts no foruma.",
   "error": "Kļūda",
   "metaIndexTitle": "Ma Petite Ferme forums — Savstarpēja palīdzība starp lopkopjiem",
   "metaIndexDesc": "Uzdodiet jautājumus par lopkopību, tiešo pārdošanu, siera ražošanu, gaļu un olām. Ma Petite Ferme lopkopju kopiena.",
   "badgeEquipe": "Komanda",
   "badgeExpert": "Eksperts",
   "badgeContrib": "Līdzdalībnieks",
   "badgeNew": "Jauns"
  },
  "elevage": {
   "volailles": "Mājputni un olas",
   "fromage-lait": "Siers un piens",
   "viande": "Gaļa",
   "maraichage": "Dārzkopība",
   "autre": "Cits"
  },
  "cats": {
   "volailles-oeufs": "Mājputni un olas",
   "fromage-lait": "Siers un piens",
   "viande": "Gaļa",
   "vente-business": "Pārdošana un bizness",
   "general-elevage": "Vispārīga lopkopība"
  },
  "subs": {
   "alimentation-sante": "Barošana un veselība",
   "production-ponte": "Ražošana un dēšana",
   "materiel-poulailler": "Aprīkojums un vistudārzs",
   "traite-sante": "Slaukšana un dzīvnieku veselība",
   "transformation-affinage": "Pārstrāde un nogatavināšana",
   "reglementation-hygiene": "Noteikumi un higiēna",
   "elevage-croissance": "Audzēšana un augšana",
   "abattage-decoupe": "Kaušana un gaļas griešana",
   "reglementation": "Noteikumi",
   "fixer-prix": "Cenu noteikšana",
   "vente-directe": "Tiešā pārdošana / īsās piegādes ķēdes",
   "communication": "Komunikācija un sociālie tīkli",
   "reglementation-declarations": "Noteikumi un deklarācijas",
   "presentation-membres": "Dalībnieku iepazīšanās",
   "suggestions": "Ieteikumi Ma Petite Ferme"
  }
 },
 "pt": {
  "ui": {
   "navForum": "Fórum",
   "backToSite": "Voltar ao site",
   "login": "Entrar",
   "logout": "Sair",
   "heroTitle": "Fórum dos criadores",
   "heroSubtitle": "Perguntas, dicas e ajuda mútua entre apaixonados pela criação. Encontre uma resposta ou inicie uma discussão.",
   "newThread": "Novo tópico",
   "searchPlaceholder": "Pesquisar um tópico…",
   "resultsFor": "resultado(s) para",
   "noResults": "Nenhum tópico encontrado. Tente outras palavras-chave.",
   "recentDiscussions": "Discussões recentes",
   "topMembers": "Membros mais ativos",
   "allCategories": "Todas as categorias",
   "subAll": "Todos",
   "sortRecent": "Recentes",
   "sortUnanswered": "Sem resposta",
   "sortResolved": "Resolvidos",
   "emptyCategory": "Nenhum tópico por enquanto. Inicie a discussão!",
   "threadOne": "tópico",
   "threadMany": "tópicos",
   "replyOne": "resposta",
   "replyMany": "respostas",
   "by": "por",
   "resolved": "Resolvido",
   "markResolved": "Marcar como resolvido",
   "unmarkResolved": "Remover resolvido",
   "pendingModeration": "Este tópico está aguardando validação pela moderação.",
   "yourReply": "Sua resposta",
   "replyPlaceholder": "Compartilhe sua experiência…",
   "replyPlaceholderGuest": "Entre para responder.",
   "publish": "Publicar",
   "loginToReply": "Entrar para responder",
   "relatedTopics": "Tópicos semelhantes",
   "threadNotFound": "Tópico não encontrado.",
   "backToForum": "Voltar ao fórum",
   "loading": "Carregando…",
   "memberNotFound": "Membro não encontrado.",
   "memberSince": "Membro desde",
   "contributionOne": "contribuição",
   "contributionMany": "contribuições",
   "memberThreads": "Tópicos de {name}",
   "memberNoThreads": "Nenhum tópico publicado por enquanto.",
   "joinForum": "Entrar no fórum",
   "forumLogin": "Acesso ao fórum",
   "registerDesc": "Crie uma conta no fórum (e-mail, apelido, senha) para participar.",
   "loginDesc": "Entre com seu e-mail e sua senha.",
   "email": "E-mail",
   "pseudo": "Apelido (visível publicamente)",
   "password": "Senha (mínimo 6 caracteres)",
   "elevageOptional": "Tipo de criação (opcional)",
   "createAccount": "Criar minha conta",
   "alreadyAccount": "Já tem uma conta?",
   "newHere": "Novo por aqui?",
   "switchToLogin": "Entrar",
   "switchToRegister": "Criar uma conta",
   "newThreadDesc": "Escolha uma categoria e descreva sua pergunta para iniciar a discussão.",
   "categoryPh": "Categoria…",
   "subcategoryPh": "Subcategoria…",
   "threadTitlePh": "Título da sua pergunta (mínimo 8 caracteres)",
   "threadBodyPh": "Descreva sua situação ou sua pergunta…",
   "cancel": "Cancelar",
   "toastPending": "Tópico criado! Ficará visível após validação (1ª mensagem de um novo membro).",
   "toastPublished": "Tópico publicado!",
   "toastReplyPending": "Sua resposta ficará visível após validação (1ª mensagem).",
   "toastReplyPublished": "Resposta publicada!",
   "toastResolvedOn": "Marcado como resolvido.",
   "toastResolvedOff": "Resolvido removido.",
   "toastWelcome": "Bem-vindo(a) ao fórum!",
   "toastConnected": "Conectado!",
   "toastLoggedOut": "Desconectado do fórum.",
   "error": "Erro",
   "metaIndexTitle": "Fórum Minha Pequena Fazenda — Ajuda mútua entre criadores",
   "metaIndexDesc": "Faça suas perguntas sobre criação, venda direta, transformação de queijo, carne e ovos. Comunidade de criadores Minha Pequena Fazenda.",
   "badgeEquipe": "Equipe",
   "badgeExpert": "Especialista",
   "badgeContrib": "Colaborador",
   "badgeNew": "Novo"
  },
  "elevage": {
   "volailles": "Aves & ovos",
   "fromage-lait": "Queijo & leite",
   "viande": "Carne",
   "maraichage": "Horticultura",
   "autre": "Outro"
  },
  "cats": {
   "volailles-oeufs": "Aves & Ovos",
   "fromage-lait": "Queijo & Leite",
   "viande": "Carne",
   "vente-business": "Venda & Negócios",
   "general-elevage": "Criação em geral"
  },
  "subs": {
   "alimentation-sante": "Alimentação & saúde",
   "production-ponte": "Produção & postura",
   "materiel-poulailler": "Equipamentos & galinheiro",
   "traite-sante": "Ordenha & saúde animal",
   "transformation-affinage": "Transformação & maturação",
   "reglementation-hygiene": "Regulamentação & higiene",
   "elevage-croissance": "Criação & crescimento",
   "abattage-decoupe": "Abate & corte",
   "reglementation": "Regulamentação",
   "fixer-prix": "Definir seus preços",
   "vente-directe": "Vender direto / circuitos curtos",
   "communication": "Comunicação & redes sociais",
   "reglementation-declarations": "Regulamentação & declarações",
   "presentation-membres": "Apresentação dos membros",
   "suggestions": "Sugestões para Minha Pequena Fazenda"
  }
 },
 "sk": {
  "ui": {
   "navForum": "Fórum",
   "backToSite": "Späť na stránku",
   "login": "Prihlásiť sa",
   "logout": "Odhlásiť sa",
   "heroTitle": "Fórum chovateľov",
   "heroSubtitle": "Otázky, rady a vzájomná pomoc medzi nadšencami chovu. Nájdite odpoveď alebo začnite diskusiu.",
   "newThread": "Nová téma",
   "searchPlaceholder": "Hľadať tému…",
   "resultsFor": "výsledok/výsledky pre",
   "noResults": "Žiadna téma sa nenašla. Skúste iné kľúčové slová.",
   "recentDiscussions": "Nedávne diskusie",
   "topMembers": "Najaktívnejší členovia",
   "allCategories": "Všetky kategórie",
   "subAll": "Všetko",
   "sortRecent": "Najnovšie",
   "sortUnanswered": "Bez odpovede",
   "sortResolved": "Vyriešené",
   "emptyCategory": "Zatiaľ žiadna téma. Začnite diskusiu!",
   "threadOne": "téma",
   "threadMany": "témy/tém",
   "replyOne": "odpoveď",
   "replyMany": "odpovede/odpovedí",
   "by": "od",
   "resolved": "Vyriešené",
   "markResolved": "Označiť ako vyriešené",
   "unmarkResolved": "Zrušiť označenie",
   "pendingModeration": "Táto téma čaká na schválenie moderátorom.",
   "yourReply": "Vaša odpoveď",
   "replyPlaceholder": "Podeľte sa o svoju skúsenosť…",
   "replyPlaceholderGuest": "Prihláste sa, aby ste mohli odpovedať.",
   "publish": "Zverejniť",
   "loginToReply": "Prihlásiť sa a odpovedať",
   "relatedTopics": "Podobné témy",
   "threadNotFound": "Téma sa nenašla.",
   "backToForum": "Späť na fórum",
   "loading": "Načítavam…",
   "memberNotFound": "Člen sa nenašiel.",
   "memberSince": "Člen od",
   "contributionOne": "príspevok",
   "contributionMany": "príspevky/príspevkov",
   "memberThreads": "Témy od {name}",
   "memberNoThreads": "Zatiaľ žiadna zverejnená téma.",
   "joinForum": "Pridať sa na fórum",
   "forumLogin": "Prihlásenie na fórum",
   "registerDesc": "Vytvorte si účet na fóre (e-mail, prezývka, heslo) a začnite sa zapájať.",
   "loginDesc": "Prihláste sa pomocou svojho e-mailu a hesla.",
   "email": "E-mail",
   "pseudo": "Prezývka (viditeľná verejne)",
   "password": "Heslo (min. 6 znakov)",
   "elevageOptional": "Typ chovu (nepovinné)",
   "createAccount": "Vytvoriť účet",
   "alreadyAccount": "Už máte účet?",
   "newHere": "Ste tu nový?",
   "switchToLogin": "Prihlásiť sa",
   "switchToRegister": "Vytvoriť účet",
   "newThreadDesc": "Vyberte kategóriu a opíšte svoju otázku, aby ste spustili diskusiu.",
   "categoryPh": "Kategória…",
   "subcategoryPh": "Podkategória…",
   "threadTitlePh": "Názov vašej otázky (min. 8 znakov)",
   "threadBodyPh": "Opíšte vašu situáciu alebo otázku…",
   "cancel": "Zrušiť",
   "toastPending": "Téma vytvorená! Bude viditeľná po schválení (1. správa nového člena).",
   "toastPublished": "Téma zverejnená!",
   "toastReplyPending": "Vaša odpoveď bude viditeľná po schválení (1. správa).",
   "toastReplyPublished": "Odpoveď zverejnená!",
   "toastResolvedOn": "Označené ako vyriešené.",
   "toastResolvedOff": "Označenie vyriešeného zrušené.",
   "toastWelcome": "Vitajte na fóre!",
   "toastConnected": "Prihlásenie úspešné!",
   "toastLoggedOut": "Odhlásený z fóra.",
   "error": "Chyba",
   "metaIndexTitle": "Fórum Ma Petite Ferme — Vzájomná pomoc medzi chovateľmi",
   "metaIndexDesc": "Pýtajte sa na chov, priamy predaj, výrobu syrov, mäso a vajcia. Komunita chovateľov Ma Petite Ferme.",
   "badgeEquipe": "Tím",
   "badgeExpert": "Expert",
   "badgeContrib": "Prispievateľ",
   "badgeNew": "Nový"
  },
  "elevage": {
   "volailles": "Hydina & vajcia",
   "fromage-lait": "Syr & mlieko",
   "viande": "Mäso",
   "maraichage": "Záhradníctvo",
   "autre": "Iné"
  },
  "cats": {
   "volailles-oeufs": "Hydina & vajcia",
   "fromage-lait": "Syr & mlieko",
   "viande": "Mäso",
   "vente-business": "Predaj & podnikanie",
   "general-elevage": "Chov všeobecne"
  },
  "subs": {
   "alimentation-sante": "Kŕmenie & zdravie",
   "production-ponte": "Produkcia & znáška",
   "materiel-poulailler": "Vybavenie & kurín",
   "traite-sante": "Dojenie & zdravie zvierat",
   "transformation-affinage": "Spracovanie & zrenie",
   "reglementation-hygiene": "Predpisy & hygiena",
   "elevage-croissance": "Chov & rast",
   "abattage-decoupe": "Porážka & mäsiarstvo",
   "reglementation": "Predpisy",
   "fixer-prix": "Stanovenie cien",
   "vente-directe": "Priamy predaj / krátke reťazce",
   "communication": "Komunikácia & sociálne siete",
   "reglementation-declarations": "Predpisy & hlásenia",
   "presentation-membres": "Predstavenie členov",
   "suggestions": "Návrhy pre Ma Petite Ferme"
  }
 },
 "sl": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Nazaj na spletno mesto",
   "login": "Prijava",
   "logout": "Odjava",
   "heroTitle": "Forum rejcev",
   "heroSubtitle": "Vprašanja, nasveti in medsebojna pomoč med ljubitelji reje. Poiščite odgovor ali začnite pogovor.",
   "newThread": "Nova tema",
   "searchPlaceholder": "Iskanje teme…",
   "resultsFor": "rezultat(i) za",
   "noResults": "Nobene teme ni bilo najdene. Poskusite z drugimi ključnimi besedami.",
   "recentDiscussions": "Nedavne razprave",
   "topMembers": "Najbolj aktivni člani",
   "allCategories": "Vse kategorije",
   "subAll": "Vse",
   "sortRecent": "Najnovejše",
   "sortUnanswered": "Brez odgovora",
   "sortResolved": "Rešene",
   "emptyCategory": "Zaenkrat ni nobene teme. Začnite pogovor!",
   "threadOne": "tema",
   "threadMany": "teme",
   "replyOne": "odgovor",
   "replyMany": "odgovori",
   "by": "avtor",
   "resolved": "Rešeno",
   "markResolved": "Označi kot rešeno",
   "unmarkResolved": "Odstrani oznako rešeno",
   "pendingModeration": "Ta tema čaka na odobritev moderatorjev.",
   "yourReply": "Vaš odgovor",
   "replyPlaceholder": "Delite svoje izkušnje…",
   "replyPlaceholderGuest": "Prijavite se, da odgovorite.",
   "publish": "Objavi",
   "loginToReply": "Prijavite se za odgovor",
   "relatedTopics": "Podobne teme",
   "threadNotFound": "Tema ni bila najdena.",
   "backToForum": "Nazaj na forum",
   "loading": "Nalaganje…",
   "memberNotFound": "Član ni bil najden.",
   "memberSince": "Član od",
   "contributionOne": "prispevek",
   "contributionMany": "prispevki",
   "memberThreads": "Teme člana {name}",
   "memberNoThreads": "Zaenkrat ni objavljenih tem.",
   "joinForum": "Pridruži se forumu",
   "forumLogin": "Prijava v forum",
   "registerDesc": "Ustvarite račun (e-pošta, vzdevek, geslo) za sodelovanje na forumu.",
   "loginDesc": "Prijavite se z e-pošto in geslom.",
   "email": "E-pošta",
   "pseudo": "Vzdevek (javno viden)",
   "password": "Geslo (najmanj 6 znakov)",
   "elevageOptional": "Vrsta reje (neobvezno)",
   "createAccount": "Ustvari račun",
   "alreadyAccount": "Že imate račun?",
   "newHere": "Ste novi?",
   "switchToLogin": "Prijava",
   "switchToRegister": "Ustvari račun",
   "newThreadDesc": "Izberite kategorijo in opišite vprašanje, da začnete razpravo.",
   "categoryPh": "Kategorija…",
   "subcategoryPh": "Podkategorija…",
   "threadTitlePh": "Naslov vašega vprašanja (najmanj 8 znakov)",
   "threadBodyPh": "Opišite svojo situacijo ali vprašanje…",
   "cancel": "Prekliči",
   "toastPending": "Tema ustvarjena! Vidna bo po odobritvi (1. sporočilo novega člana).",
   "toastPublished": "Tema objavljena!",
   "toastReplyPending": "Vaš odgovor bo viden po odobritvi (1. sporočilo).",
   "toastReplyPublished": "Odgovor objavljen!",
   "toastResolvedOn": "Označeno kot rešeno.",
   "toastResolvedOff": "Oznaka rešeno odstranjena.",
   "toastWelcome": "Dobrodošli na forumu!",
   "toastConnected": "Prijavljeni ste!",
   "toastLoggedOut": "Odjavljeni ste iz foruma.",
   "error": "Napaka",
   "metaIndexTitle": "Forum Ma Petite Ferme — Medsebojna pomoč med rejci",
   "metaIndexDesc": "Postavite vprašanja o reji, neposredni prodaji, predelavi sira, mesu in jajcih. Skupnost rejcev Ma Petite Ferme.",
   "badgeEquipe": "Ekipa",
   "badgeExpert": "Strokovnjak",
   "badgeContrib": "Sodelavec",
   "badgeNew": "Nov član"
  },
  "elevage": {
   "volailles": "Perutnina & jajca",
   "fromage-lait": "Sir & mleko",
   "viande": "Meso",
   "maraichage": "Vrtnarstvo",
   "autre": "Drugo"
  },
  "cats": {
   "volailles-oeufs": "Perutnina & Jajca",
   "fromage-lait": "Sir & Mleko",
   "viande": "Meso",
   "vente-business": "Prodaja & Posel",
   "general-elevage": "Splošna reja"
  },
  "subs": {
   "alimentation-sante": "Prehrana & zdravje",
   "production-ponte": "Pridelava & nesnost",
   "materiel-poulailler": "Oprema & kokošnjak",
   "traite-sante": "Molža & zdravje živali",
   "transformation-affinage": "Predelava & zorenje",
   "reglementation-hygiene": "Predpisi & higiena",
   "elevage-croissance": "Reja & rast",
   "abattage-decoupe": "Zakol & razrez",
   "reglementation": "Predpisi",
   "fixer-prix": "Določanje cen",
   "vente-directe": "Neposredna prodaja / kratke verige",
   "communication": "Komunikacija & družbena omrežja",
   "reglementation-declarations": "Predpisi & prijave",
   "presentation-membres": "Predstavitev članov",
   "suggestions": "Predlogi za Ma Petite Ferme"
  }
 },
 "ro": {
  "ui": {
   "navForum": "Forum",
   "backToSite": "Înapoi pe site",
   "login": "Conectare",
   "logout": "Deconectare",
   "heroTitle": "Forumul crescătorilor",
   "heroSubtitle": "Întrebări, sfaturi și ajutor reciproc între pasionații de creșterea animalelor. Găsiți un răspuns sau lansați o discuție.",
   "newThread": "Subiect nou",
   "searchPlaceholder": "Caută un subiect…",
   "resultsFor": "rezultat(e) pentru",
   "noResults": "Niciun subiect găsit. Încearcă alte cuvinte cheie.",
   "recentDiscussions": "Discuții recente",
   "topMembers": "Cei mai activi membri",
   "allCategories": "Toate categoriile",
   "subAll": "Toate",
   "sortRecent": "Recente",
   "sortUnanswered": "Fără răspuns",
   "sortResolved": "Rezolvate",
   "emptyCategory": "Niciun subiect deocamdată. Lansați discuția!",
   "threadOne": "subiect",
   "threadMany": "subiecte",
   "replyOne": "răspuns",
   "replyMany": "răspunsuri",
   "by": "de",
   "resolved": "Rezolvat",
   "markResolved": "Marchează ca rezolvat",
   "unmarkResolved": "Elimină rezolvat",
   "pendingModeration": "Acest subiect așteaptă validarea de către moderatori.",
   "yourReply": "Răspunsul tău",
   "replyPlaceholder": "Împărtășiți-vă experiența…",
   "replyPlaceholderGuest": "Conectați-vă pentru a răspunde.",
   "publish": "Publică",
   "loginToReply": "Conectați-vă pentru a răspunde",
   "relatedTopics": "Subiecte similare",
   "threadNotFound": "Subiectul nu a fost găsit.",
   "backToForum": "Înapoi la forum",
   "loading": "Se încarcă…",
   "memberNotFound": "Membrul nu a fost găsit.",
   "memberSince": "Membru din",
   "contributionOne": "contribuție",
   "contributionMany": "contribuții",
   "memberThreads": "Subiectele lui {name}",
   "memberNoThreads": "Niciun subiect publicat deocamdată.",
   "joinForum": "Alătură-te forumului",
   "forumLogin": "Conectare la forum",
   "registerDesc": "Creați un cont de forum (email, pseudonim, parolă) pentru a participa.",
   "loginDesc": "Conectați-vă cu adresa de email și parola.",
   "email": "E-mail",
   "pseudo": "Pseudonim (vizibil public)",
   "password": "Parolă (minim 6 caractere)",
   "elevageOptional": "Tip de creștere (opțional)",
   "createAccount": "Creează-mi contul",
   "alreadyAccount": "Ai deja un cont?",
   "newHere": "Ești nou?",
   "switchToLogin": "Conectare",
   "switchToRegister": "Creare cont",
   "newThreadDesc": "Alegeți o categorie și descrieți întrebarea dvs. pentru a lansa discuția.",
   "categoryPh": "Categorie…",
   "subcategoryPh": "Subcategorie…",
   "threadTitlePh": "Titlul întrebării dvs. (minim 8 caractere)",
   "threadBodyPh": "Descrieți situația sau întrebarea dvs.…",
   "cancel": "Anulează",
   "toastPending": "Subiect creat! Va fi vizibil după validare (primul mesaj al unui nou membru).",
   "toastPublished": "Subiect publicat!",
   "toastReplyPending": "Răspunsul dvs. va fi vizibil după validare (primul mesaj).",
   "toastReplyPublished": "Răspuns publicat!",
   "toastResolvedOn": "Marcat ca rezolvat.",
   "toastResolvedOff": "Rezolvat eliminat.",
   "toastWelcome": "Bun venit pe forum!",
   "toastConnected": "Conectat!",
   "toastLoggedOut": "Deconectat de la forum.",
   "error": "Eroare",
   "metaIndexTitle": "Forumul Fermei Mele Mici — Ajutor reciproc între crescători",
   "metaIndexDesc": "Puneți întrebări despre creșterea animalelor, vânzarea directă, producția de brânzeturi, carne și ouă. Comunitatea crescătorilor de la Ferma Mea Mică.",
   "badgeEquipe": "Echipă",
   "badgeExpert": "Expert",
   "badgeContrib": "Contributor",
   "badgeNew": "Nou"
  },
  "elevage": {
   "volailles": "Păsări de curte & ouă",
   "fromage-lait": "Brânzeturi & lapte",
   "viande": "Carne",
   "maraichage": "Legumicultură",
   "autre": "Altele"
  },
  "cats": {
   "volailles-oeufs": "Păsări de curte & Ouă",
   "fromage-lait": "Brânzeturi & Lapte",
   "viande": "Carne",
   "vente-business": "Vânzări & Afaceri",
   "general-elevage": "Creștere animale — General"
  },
  "subs": {
   "alimentation-sante": "Alimentație & sănătate",
   "production-ponte": "Producție & ouat",
   "materiel-poulailler": "Echipament & cotet",
   "traite-sante": "Muls & sănătatea animalelor",
   "transformation-affinage": "Procesare & maturare",
   "reglementation-hygiene": "Reglementări & igienă",
   "elevage-croissance": "Creștere & dezvoltare",
   "abattage-decoupe": "Sacrificare & tranșare",
   "reglementation": "Reglementări",
   "fixer-prix": "Stabilirea prețurilor",
   "vente-directe": "Vânzare directă / circuite scurte",
   "communication": "Comunicare & rețele sociale",
   "reglementation-declarations": "Reglementări & declarații",
   "presentation-membres": "Prezentarea membrilor",
   "suggestions": "Sugestii pentru Ferma Mea Mică"
  }
 },
 "cs": {
  "ui": {
   "navForum": "Fórum",
   "backToSite": "Zpět na web",
   "login": "Přihlásit se",
   "logout": "Odhlásit se",
   "heroTitle": "Fórum chovatelů",
   "heroSubtitle": "Otázky, rady a vzájemná pomoc mezi nadšenými chovateli. Najděte odpověď nebo zahajte diskusi.",
   "newThread": "Nové téma",
   "searchPlaceholder": "Hledat téma…",
   "resultsFor": "výsledek/výsledků pro",
   "noResults": "Žádné téma nenalezeno. Zkuste jiná klíčová slova.",
   "recentDiscussions": "Nedávné diskuse",
   "topMembers": "Nejaktivnější členové",
   "allCategories": "Všechny kategorie",
   "subAll": "Vše",
   "sortRecent": "Nedávné",
   "sortUnanswered": "Bez odpovědi",
   "sortResolved": "Vyřešené",
   "emptyCategory": "Zatím žádné téma. Zahajte diskusi!",
   "threadOne": "téma",
   "threadMany": "témat",
   "replyOne": "odpověď",
   "replyMany": "odpovědí",
   "by": "od",
   "resolved": "Vyřešeno",
   "markResolved": "Označit jako vyřešené",
   "unmarkResolved": "Zrušit označení vyřešeno",
   "pendingModeration": "Toto téma čeká na schválení moderátorem.",
   "yourReply": "Vaše odpověď",
   "replyPlaceholder": "Podělte se o své zkušenosti…",
   "replyPlaceholderGuest": "Pro odpověď se přihlaste.",
   "publish": "Zveřejnit",
   "loginToReply": "Přihlaste se pro odpověď",
   "relatedTopics": "Podobná témata",
   "threadNotFound": "Téma nenalezeno.",
   "backToForum": "Zpět na fórum",
   "loading": "Načítání…",
   "memberNotFound": "Člen nenalezen.",
   "memberSince": "Členem od",
   "contributionOne": "příspěvek",
   "contributionMany": "příspěvků",
   "memberThreads": "Témata od {name}",
   "memberNoThreads": "Zatím žádná zveřejněná témata.",
   "joinForum": "Připojit se k fóru",
   "forumLogin": "Přihlášení do fóra",
   "registerDesc": "Vytvořte si účet (e-mail, přezdívka, heslo) a zapojte se do komunity.",
   "loginDesc": "Přihlaste se pomocí e-mailu a hesla.",
   "email": "E-mail",
   "pseudo": "Přezdívka (viditelná veřejně)",
   "password": "Heslo (min. 6 znaků)",
   "elevageOptional": "Typ chovu (nepovinné)",
   "createAccount": "Vytvořit účet",
   "alreadyAccount": "Už máte účet?",
   "newHere": "Nový zde?",
   "switchToLogin": "Přihlásit se",
   "switchToRegister": "Vytvořit účet",
   "newThreadDesc": "Vyberte kategorii a popište svou otázku, abyste zahájili diskusi.",
   "categoryPh": "Kategorie…",
   "subcategoryPh": "Podkategorie…",
   "threadTitlePh": "Název vaší otázky (min. 8 znaků)",
   "threadBodyPh": "Popište svou situaci nebo otázku…",
   "cancel": "Zrušit",
   "toastPending": "Téma vytvořeno! Bude viditelné po schválení (1. zpráva nového člena).",
   "toastPublished": "Téma zveřejněno!",
   "toastReplyPending": "Vaše odpověď bude viditelná po schválení (1. zpráva).",
   "toastReplyPublished": "Odpověď zveřejněna!",
   "toastResolvedOn": "Označeno jako vyřešené.",
   "toastResolvedOff": "Označení vyřešeno odstraněno.",
   "toastWelcome": "Vítejte na fóru!",
   "toastConnected": "Přihlášení proběhlo úspěšně!",
   "toastLoggedOut": "Odhlášení z fóra proběhlo úspěšně.",
   "error": "Chyba",
   "metaIndexTitle": "Fórum Ma Petite Ferme — Vzájemná pomoc mezi chovateli",
   "metaIndexDesc": "Ptejte se na chov, přímý prodej, výrobu sýrů, maso a vejce. Komunita chovatelů Ma Petite Ferme.",
   "badgeEquipe": "Tým",
   "badgeExpert": "Expert",
   "badgeContrib": "Přispěvatel",
   "badgeNew": "Nový"
  },
  "elevage": {
   "volailles": "Drůbež & vejce",
   "fromage-lait": "Sýr & mléko",
   "viande": "Maso",
   "maraichage": "Zelinářství",
   "autre": "Ostatní"
  },
  "cats": {
   "volailles-oeufs": "Drůbež & vejce",
   "fromage-lait": "Sýr & mléko",
   "viande": "Maso",
   "vente-business": "Prodej & podnikání",
   "general-elevage": "Obecný chov"
  },
  "subs": {
   "alimentation-sante": "Výživa & zdraví",
   "production-ponte": "Produkce & snášení",
   "materiel-poulailler": "Vybavení & kurník",
   "traite-sante": "Dojení & zdraví zvířat",
   "transformation-affinage": "Zpracování & zrání",
   "reglementation-hygiene": "Předpisy & hygiena",
   "elevage-croissance": "Chov & růst",
   "abattage-decoupe": "Porážka & bourání",
   "reglementation": "Předpisy",
   "fixer-prix": "Stanovení cen",
   "vente-directe": "Přímý prodej / krátké odbytové řetězce",
   "communication": "Komunikace & sociální sítě",
   "reglementation-declarations": "Předpisy & ohlašovací povinnosti",
   "presentation-membres": "Představení členů",
   "suggestions": "Návrhy pro Ma Petite Ferme"
  }
 }
};
